import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { useHistory, useParams, Prompt } from "react-router";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCirclePlus } from "@fortawesome/pro-thin-svg-icons";
import { faSpinnerThird } from "@fortawesome/pro-duotone-svg-icons";
import { faCircleCheck, faCircleXmark } from "@fortawesome/pro-solid-svg-icons";
import {
  faArrowLeft,
  faCartCircleXmark,
  faCheck,
  faClock,
  faPlus,
  faTrashCan,
  faTrashCanXmark,
} from "@fortawesome/pro-regular-svg-icons";
import { useStripe } from "@stripe/react-stripe-js";
import { dequeue, enqueue, initiateEditBooking, showError, showSuccess } from "redux/actions/ui";
import { loadDiscountOptions, loadPaymentOptions } from "redux/actions/facility";
import { selectTeeTime, selectTeeTimeSuccess } from "redux/actions/teesheet";
import { updateTeeSheetProducts } from "redux/actions/facilityAdmin/teeSheetProducts";
import { IProduct, IVariant } from "redux/reducers/models/product";
import { ICustomer } from "redux/reducers/models/customer";
import { ICart } from "redux/reducers/models/cart";
import { IOrder } from "redux/reducers/models/order";
import { IBooking, IBookingParticipant, ISlot, ITeeTime } from "redux/reducers/models/teetime";
import { StatusCode } from "api/protocols";
import {
  GetTicketStubRedemption,
  GetTicketValidate,
  PutTicketStubRedeemMultiple,
} from "api/rpc/2024-04/facilityAdmin/ticket/stub";
import { IGetTicketValidateRes } from "api/rpc/2022-09/facilityAdmin/ticket/ticket";
import { PutRedeem, GetTicketStub } from "api/rpc/2024-04/facilityAdmin/ticket/ticket";
import {
  DeleteLineItemToCart,
  PostLineItemToCart,
  PutLineItemToCart,
} from "api/rpc/2024-04/facilityAdmin/order/cart/lineItem";
import { PostTransaction, PutCapture } from "api/rpc/2022-09/facilityAdmin/order/transaction";
import {
  GetBooking,
  PutCancelParticipant,
  PutCheckParticipantAll,
} from "api/rpc/2022-09/facilityAdmin/teesheet/booking";
import { convertTime, customerErrorMessage, errorMessage } from "helpers/Helpers";
import { LocaleCurrency } from "helpers/Locale";
import Products, { IProductState } from "elements/register/Products";

import Input from "components/form/input/Input";
import Sheet from "components/sheet/Sheet";
import Divider from "components/divider";
import Callout from "components/callout/Callout";
import Checkbox from "components/form/checkbox/Checkbox";
import { Select } from "components/select/index";
import { ButtonNew as Button } from "components/buttonNew/index";
import Tabs from "components/tabs/Tabs";
import Popup from "components/popup/Popup";
import OrderCompletePopup from "components/orderCompletePopup/OrderCompletePopup";
import { Badge } from "components/badge/Badge";
import "../styles.scss";
import axios, { CancelToken } from "axios";
import Markdown from "components/markdown/Markdown";
import Spin from "components/spin/spin";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { NavigationDropdownNew } from "components/navigationDropdownNew/NavigationDropdownNew";
import Portal from "elements/Portal";
import DataTable from "../../../../../components/dataTable/DataTable";
import CartMenuNew from "../../register/registerNew/CartMenuNew";
import { TParticipantPaidFees, useRegisterContext } from "../../register/registerNew/RegisterContext";
import NewTeeSheetBookingDisplay from "./NewTeeSheetBookingDisplay";
import { GetProduct } from "api/rpc/2024-04/facilityAdmin/product/product";
import { GetFolder } from "api/rpc/2024-04/facilityAdmin/product/folder";
import { GetTeeTime, GetTeeTimeCartsAvailable, PostTeeTimeLock } from "api/rpc/2024-04/facilityAdmin/teesheet/teeSheet";
import BookingModalEdit from "../newTeeSheet/modals/BookingModalEdit";
import useModal from "hooks/modals/useModal";
import PaceTracker from "elements/teesheet/paceTracker/PaceTracker";
import { getGroupPaceTimes } from "elements/teesheet/paceTracker/paceTrackerUtils";
import FormLayout from "components/form/FormLayout";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { IStub } from "redux/reducers/models/ticket";
import {
  buildRedemptionItemVariantsFromStub,
  expandTicketStubIds,
  getAssignmentGreenFeeVariantId,
  getAssignmentPowerCartVariantId,
  getAssignmentRedemptionQuantities,
  getMaxRedemptionQuantity,
  getParticipantRedemptionAssignmentCount,
  getRedemptionItemSlots,
  getRedemptionUseCount,
  getTicketRedemptionQuantity,
  isMultiUseTicket,
  isSlotEligibleForTicketFeeRedemption,
  stubHasFeeRedemptionProducts,
  stubHasItemRedemptionProducts,
  stubHasRedemptionProducts,
  TicketRedemptionQuantityMap,
} from "helpers/ticketRedemption";
import TicketRedemptionQuantityInput from "components/ticketRedemption/TicketRedemptionQuantityInput";
import "components/ticketRedemption/ticketRedemption.scss";
import { TSku } from "../../settings/inventoryCounts/NewInventoryCount";
import { cloneDeep } from "lodash";
import {
  GetCartWaiver,
  PostNoShowChargeAudit,
  PostNoShowEmail,
  PutBookingParticipant,
  PutBookingParticipantNoShow,
  PutBookingParticipantRemoveNoShow,
  PutBookingWaiversPrinted,
} from "api/rpc/2024-04/facilityAdmin/teesheet/booking";
import { PostRedeemRainCheck } from "api/rpc/2024-04/facilityAdmin/payment/rainCheck";
import IssueRainCheckModal from "../newTeeSheet/modals/IssueRainCheckModal";
import ChangeCustomer from "components/changeCustomer/ChangeCustomer";
import {
  GetCustomer,
  GetCustomerPaymentMethod,
  PostCustomer,
  PostCustomerNote,
} from "api/rpc/2024-04/facilityAdmin/customer/customer";
import { PostLineItemsToOrder, PostOrder } from "api/rpc/2024-04/facilityAdmin/order/order";
import RainCheckRedeem from "components/rainCheckRedeem/RainCheckRedeem";

import { PutCart } from "api/rpc/2024-04/facilityAdmin/cart/cart";
import { PrintLiabilityWaiver } from "api/rpc/2024-04/facilityAdmin/facility/liabilityWaiver";
import { GetBookingDeposit, IBookingDeposit } from "api/rpc/2024-04/facilityAdmin/deposit/deposit";
import DuplicateBookingModal from "components/duplicateBookingModal/DuplicateBookingModal";
import { PostCart } from "api/rpc/2024-04/facilityAdmin/order/cart/cart";

export const enum OrderProgress {
  NEW_ORDER,
  CREATING_CART,
  ADDING_FEES,
  ORDER_IN_PROGRESS,
}

export interface IOrderProgess {
  orderStep: OrderProgress;
}
interface ICheckInState {
  cart: ICart;
  order: IOrder;
  redeemTicketActive: boolean;
  redeemTicketSelected: number;
  redeem_ticket_code: string;
  ticketValidSuccess: boolean;
  ticketValidWarning: boolean;
  availableTickets: IStub[];
  availableTicketsOffset: number;
  getTicketValidateData: IGetTicketValidateRes["data"] | Partial<IGetTicketValidateRes["data"]>;
  cancelOrderActive: boolean;
  manualCheckInVisible: boolean;
  manualCheckInSlot: ISlot;
  ticketRedeemSuccess: boolean;
  selectedTickets: IStub[];
  selectedCustomerTickets: IStub[];
  selectedCustomerTicketQuantities: TicketRedemptionQuantityMap;
  selectedTicketQuantities: TicketRedemptionQuantityMap;
  ticketCustomerId: number;
  ticketParticipantId: number;
  ticketPendingStubIds: Array<number>;
}

const TICKET_LIMIT = 50;

interface ISavedTicketPage {
  pageNumber: number;
  ticket: any;
  selectedGreenFeeParticipants: number[];
  selectedPowerCartParticipants: number[];
}

interface IRedeemTicketState {
  currentTicket: any;
  greenFeeQuantity: number;
  powerCartQuantity: number;
  greenFeeMultipleTicketParticipantIds: number[];
  powerCartMultipleTicketParticipantIds: number[];

  //State to control ticket pages
  redeemingMultipleTickets: boolean;
  multipleTicketParticipants: IBookingParticipant[];
  ticketsToRedeem: any[];
  selectedTickets: any[];
  totalTicketPages: number;
  currentTicketPage: number;
  savedTicketPages: ISavedTicketPage[];
  assigningMultiUseTicket: boolean;
}

interface IMainState {
  selectedBooking: IBooking;
  teeTimeLock: boolean;
  teeTimeCancelledPopupVisible: boolean;
  clearCartActive: boolean;
  powerCartModalVisible: boolean;
  applyDynamicPricing: boolean;
  applyDynamicPricingModal: boolean;
  dynamicPricingVariant: IVariant | null;
  promptCartNumberSlot: ISlot | null;
}

interface IAddItemState {
  greenFeeActive: boolean;
  powerCartFeeActive: boolean;
  itemSearchResult: IProduct[];
  participant_id: number;
  tee_time_id: number;
  greenfeeSearchQuery: string;
  cartSearchQuery: string;
  foundGreenFees: IProduct[];
  foundCartItems: IProduct[];
  productState: IProductState;
  selectedSlot: ISlot;
  participantFeeLoadingMessage: string;
  selectedProductType: "Green Fee" | "Power Cart";
  greenFeeFolderItems: IProduct[] | null;
  powerCartFolderItems: IProduct[] | null;
}

interface INoShowState {
  noShowActive: boolean;
  bookingParticipantIds: Array<number>;
  quantity: number;
  greenFeeProductID: number;
  greenFeeProductTitle: string;
  greenFeeProductPrice: number;
  paymentMethodID: string;
  customerID: number;
  teeTimeBookingId: number;
  greenFeeProducts: IProduct[];
  noPaymentMethodModal: boolean;
}

interface IRainCheckState {
  rainCheckActive: boolean;
  /** Set when issuing from a single player, so the modal can skip player selection. */
  selectedBookingParticipantId: number;

  redeemRainCheckActive: boolean;
  redeemRainCheckCode: string;
}
interface IGroupPayState {
  groupPayActive: boolean;
  groupPayTeeTimes: ITeeTime[];
  playerSearch: string;
}

type FeeStatusType = {
  [id: number]: {
    greenFeeChecked: boolean;
    powerCartChecked: boolean;
  };
};

interface IChangePlayerState {
  showChangePlayer: boolean;
  showNewPlayer: boolean;
  customerQuery: string;
  customerSearching: boolean;
  playerSearchResult: Array<ICustomer>;
  selectedCustomer: ICustomer;
  first_name: string;
  last_name: string;
  phone: string;
  email: string;
  bookingParticipant: IBookingParticipant;
}

interface IOrderComplete {
  isOpen: boolean;
  clearOnClose: boolean;
  loading: boolean;
  transactionComplete: boolean;
}

export interface ICustomerInfoState {
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber: string;
}

interface ITicketState {
  tickets: Array<TSku>;
  ticketString: string;
}

export enum StateType {
  MainState = "IMainState",
  AddItemState = "IAddItemState",
  CheckInState = "ICheckInState",
  OrderProgress = "IOrderProgess",
  NoShowState = "INoShowState",
  RainCheckState = "IRainCheckState",
  GroupPayState = "IGroupPayState",
  OrderComplete = "OrderComplete",
}

const NewTeeSheetDetails: React.FC = () => {
  const { teetimeId } = useParams<{ teetimeId: string }>();
  const stripe = useStripe();
  const { t } = useTranslation();
  const { teeSheetStore, uiStore, facilityStore, teeSheetProductStore } = useAppSelector(store => store);
  const { Option } = Select;
  const {
    addLoadingVariant,
    removeLoadingVariant,
    addLineItemUpdating,
    removeLineItemUpdating,
    lineItemsUpdating,
    participantPaidFees,
    updateParticipantPaidFees,
    initializeParticipantPaidFees,
    registerState,
    updateRegisterState,
  } = useRegisterContext();

  const history = useHistory();
  const dispatch = useAppDispatch();

  const {
    state: duplicateBookingModal,
    updateModal: updateDuplicateBookingModal,
    closeModal: closeDuplicateBookingModal,
  } = useModal<{ booking: IBooking; teeTime: ITeeTime }>({ booking: null, teeTime: null });

  const [orderProgress, setOrderProgress] = useState<IOrderProgess>({
    orderStep: OrderProgress.NEW_ORDER,
  });

  const [noShow, setNoShow] = useState<INoShowState>({
    noShowActive: false,
    bookingParticipantIds: [],
    quantity: 0,
    greenFeeProductID: null,
    greenFeeProductTitle: "",
    greenFeeProductPrice: null,
    paymentMethodID: "",
    customerID: null,
    teeTimeBookingId: null,
    greenFeeProducts: [],
    noPaymentMethodModal: false,
  });

  const [addItemState, setAddItemState] = useState<IAddItemState>({
    greenFeeActive: false,
    powerCartFeeActive: false,
    itemSearchResult: [],
    participant_id: null,
    tee_time_id: null,
    greenfeeSearchQuery: "",
    cartSearchQuery: "",
    foundGreenFees: [],
    foundCartItems: [],
    productState: {
      selectedProduct: undefined,
      variants: [],
      variantSheetOpen: false,
    },
    selectedSlot: null,
    participantFeeLoadingMessage: null,
    selectedProductType: null,
    greenFeeFolderItems: null,
    powerCartFolderItems: null,
  });

  const [foundGreenFees, setFoundGreenFees] = useState<IProduct[]>(addItemState.foundGreenFees);
  const [foundCartItems, setFoundCartItems] = useState<IProduct[]>(addItemState.foundCartItems);

  const [reviewPlayersModalVisable, setReviewPlayersModalVisable] = useState(false);
  const [paceTrackerVisible, setPaceTrackerVisible] = useState(false);
  const initialReviewPlayersModalOpen = useRef(false);

  const [checkInState, setCheckInState] = useState<ICheckInState>({
    cart: null,
    order: undefined,
    redeemTicketActive: false,
    redeemTicketSelected: 0,
    redeem_ticket_code: "",
    ticketValidSuccess: false,
    ticketValidWarning: false,
    getTicketValidateData: {},
    availableTickets: [],
    availableTicketsOffset: 0,
    cancelOrderActive: false,
    manualCheckInVisible: false,
    manualCheckInSlot: null,
    ticketRedeemSuccess: false,
    selectedTickets: [],
    selectedCustomerTickets: [],
    selectedCustomerTicketQuantities: {},
    selectedTicketQuantities: {},
    ticketCustomerId: null,
    ticketParticipantId: null,
    ticketPendingStubIds: [],
  });

  const [state, setState] = useState<IMainState>({
    selectedBooking: null,
    teeTimeLock: false,
    teeTimeCancelledPopupVisible: false,
    clearCartActive: false,
    powerCartModalVisible: false,
    applyDynamicPricing: true,
    applyDynamicPricingModal: false,
    dynamicPricingVariant: null,
    promptCartNumberSlot: null,
  });

  const [rainCheckState, setRainCheckState] = useState<IRainCheckState>({
    //Issue Rain Check
    rainCheckActive: false,
    selectedBookingParticipantId: null,

    //Redeem Rain Check
    redeemRainCheckActive: false,
    redeemRainCheckCode: "",
  });

  const [groupPayState, setGroupPayState] = useState<IGroupPayState>({
    groupPayActive: false,
    groupPayTeeTimes: null,
    playerSearch: "",
  });

  const [changePlayerState, setChangePlayerState] = useState<IChangePlayerState>({
    showChangePlayer: false,
    showNewPlayer: false,
    customerQuery: "",
    customerSearching: false,
    playerSearchResult: [],
    selectedCustomer: null,
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    bookingParticipant: null,
  });

  const [orderCompletePopup, setOrderCompletePopup] = useState<IOrderComplete>({
    isOpen: false,
    clearOnClose: true,
    loading: false,
    transactionComplete: false,
  });

  const checkedInParticipantIds = (participantPaidFees.current ?? [])
    .filter(participant => participant?.green_fee || participant?.power_cart_fee)
    .map(participant => participant.booking_participant_id)
    .filter((id): id is number => id != null);
  const slots = teeSheetStore.selectedTeeTime?.slots ?? [];
  const firstCheckedInSlot = slots.find(slot => {
    const participantId = slot.booking_participant?.id ?? slot.tee_time_booking_participant_id;
    return participantId != null && checkedInParticipantIds.includes(participantId);
  });
  const orderLinkedBooking =
    checkInState.order?.id != null
      ? slots.find(slot => Number(slot.booking?.order_id) === Number(checkInState.order?.id))?.booking
      : undefined;
  const cartWaiverBookingId =
    firstCheckedInSlot?.tee_time_booking_id ??
    firstCheckedInSlot?.booking?.id ??
    firstCheckedInSlot?.booking_participant?.tee_time_booking_id ??
    orderLinkedBooking?.id;
  const cartWaiverBooking =
    firstCheckedInSlot?.booking ??
    orderLinkedBooking ??
    (cartWaiverBookingId == null
      ? undefined
      : slots.find(
          slot => Number(slot.booking?.id ?? slot.tee_time_booking_id) === Number(cartWaiverBookingId),
        )?.booking);
  const cartWaiverLimit = Math.max(Math.ceil((cartWaiverBooking?.quantity ?? 0) / 2), 1);
  const cartWaiversPrinted = cartWaiverBooking?.waivers_printed ?? 0;

  // Survives popup close / tee-time refresh races so sequential check-ins don't re-read a stale count.
  const cartWaiverPrintedCountsRef = useRef<Record<string, number>>({});
  // Holds booking id + limit for the open order-complete popup after participantPaidFees is reset.
  const cartWaiverSnapshotRef = useRef<{ bookingId: number; limit: number } | null>(null);

  const activeCartWaiverBookingId =
    cartWaiverSnapshotRef.current?.bookingId ??
    (cartWaiverBookingId != null ? Number(cartWaiverBookingId) : undefined);
  const activeCartWaiverLimit = cartWaiverSnapshotRef.current?.limit ?? cartWaiverLimit;
  const activeCartWaiversPrinted =
    activeCartWaiverBookingId != null
      ? Math.max(
          Number(cartWaiverBookingId) === activeCartWaiverBookingId ? cartWaiversPrinted : 0,
          cartWaiverPrintedCountsRef.current[String(activeCartWaiverBookingId)] ?? 0,
        )
      : cartWaiversPrinted;

  const { state: editBookingModal, updateModal: updateEditBookingModal } = useModal({
    clearOnClose: true,
    selectedTeeTime: null,
    selectedBooking: null,
    teeTimeLock: false,
    loading: false,
    loadingText: "",
    postingLock: false,
    cartsAvailable: {
      nineHole: 0,
      eighteenHole: 0,
    },
  });

  const [ticketState, setTicketState] = useState<ITicketState>({
    tickets: [],
    ticketString: "",
  });

  const [redeemTicketState, setRedeemTicketState] = useState<IRedeemTicketState>({
    ticketsToRedeem: [],
    selectedTickets: [],
    currentTicket: null,
    powerCartQuantity: 0,
    greenFeeQuantity: 0,
    powerCartMultipleTicketParticipantIds: [],
    greenFeeMultipleTicketParticipantIds: [],
    redeemingMultipleTickets: false,
    multipleTicketParticipants: [],
    totalTicketPages: null,
    currentTicketPage: 0,
    savedTicketPages: [],
    assigningMultiUseTicket: false,
  });

  const [deposits, setDeposits] = useState<Array<IBookingDeposit>>([]);
  const [refreshDeposits, setRefreshDeposits] = useState<boolean>(false);

  // Stubs that have been applied to the participants and passed to the receipt endpoint to show multi-use ticket redemptions left
  const [stubsToRedeem, setStubsToRedeem] = useState<Array<number>>([]);

  useEffect(() => {
    if (!orderCompletePopup?.isOpen) {
      // Reset redeemed stubs state on order complete
      setStubsToRedeem([]);
      cartWaiverSnapshotRef.current = null;
      return;
    }
    if (cartWaiverSnapshotRef.current != null || cartWaiverBookingId == null) {
      return;
    }
    const bookingId = Number(cartWaiverBookingId);
    const knownPrinted = cartWaiverPrintedCountsRef.current[String(bookingId)] ?? 0;
    cartWaiverPrintedCountsRef.current[String(bookingId)] = Math.max(cartWaiversPrinted, knownPrinted);
    cartWaiverSnapshotRef.current = {
      bookingId,
      limit: cartWaiverLimit,
    };
  }, [orderCompletePopup?.isOpen, cartWaiverBookingId, cartWaiverLimit, cartWaiversPrinted]);

  useEffect(() => {
    if (!initialReviewPlayersModalOpen?.current && teeSheetStore?.selectedTeeTime && facilityStore?.teeSheetSettings) {
      let openModal = false;
      if (facilityStore?.facility?.display_review_players_modal) {
        if (
          !facilityStore?.teeSheetSettings?.review_players_modal_customer_types ||
          facilityStore?.teeSheetSettings?.review_players_modal_customer_types?.length === 0 ||
          facilityStore?.teeSheetSettings?.review_players_modal_customer_types?.some(type =>
            teeSheetStore?.selectedTeeTime?.slots?.some(
              slot => slot?.booking_participant?.customer?.customer_type_id === type,
            ),
          )
        ) {
          openModal = true;
          initialReviewPlayersModalOpen.current = true;
        }
      }
      setReviewPlayersModalVisable(openModal);
    }
  }, [teeSheetStore?.selectedTeeTime, facilityStore?.teeSheetSettings]);

  useEffect(() => {
    //Initialize the tee time
    void refreshTeeTime(true, true);

    //Show warning dialog box when browser is refreshed
    function handleBeforeUnload(event: BeforeUnloadEvent) {
      event.preventDefault();
      event.returnValue = "";
      return "";
    }
    //Initialize payment methods
    if (!facilityStore?.paymentOptions || facilityStore?.paymentOptions?.length === 0) {
      void dispatch(loadPaymentOptions());
    }
    //Initialize discount options
    if (facilityStore?.discountOptions?.length === 0) {
      void dispatch(loadDiscountOptions());
    }

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  useEffect(() => {
    if (refreshDeposits) {
      void getDeposits(teeSheetStore?.selectedTeeTime);
      setRefreshDeposits(false);
    }
  }, [refreshDeposits]);

  useEffect(() => {
    // If there are no bookings in the selected tee time, return to the tee sheet
    if (
      teeSheetStore.selectedTeeTime &&
      teeSheetStore.selectedTeeTime?.quantity_remaining === teeSheetStore.selectedTeeTime?.slots?.length
    ) {
      history.push(`/admin/teesheet`, { params: { preserveTeeSheetDate: true } });
    }
  }, [teeSheetStore.selectedTeeTime]);

  //Group Pay Tee Times
  useEffect(() => {
    const source = axios.CancelToken.source();
    if (groupPayState.groupPayActive) {
      void loadGroupPayTeeTimes(source.token);
    }
    return () => source.cancel();
  }, [groupPayState.groupPayActive]);

  function updateState<T>(newState: Partial<T>, type: StateType) {
    const states = {
      [StateType.MainState]: (newState: Partial<T>) =>
        setState((cur: IMainState) => {
          return { ...cur, ...newState };
        }),
      [StateType.AddItemState]: (newState: Partial<T>) =>
        setAddItemState((cur: IAddItemState) => {
          return { ...cur, ...newState };
        }),
      [StateType.CheckInState]: (newState: Partial<T>) =>
        setCheckInState((cur: ICheckInState) => {
          return { ...cur, ...newState };
        }),
      [StateType.OrderProgress]: (newState: Partial<T>) =>
        setOrderProgress((cur: IOrderProgess) => {
          return { ...cur, ...newState };
        }),

      [StateType.NoShowState]: (newState: Partial<T>) =>
        setNoShow((cur: INoShowState) => {
          return { ...cur, ...newState };
        }),
      [StateType.RainCheckState]: (newState: Partial<T>) =>
        setRainCheckState((cur: IRainCheckState) => {
          return { ...cur, ...newState };
        }),
      [StateType.GroupPayState]: (newState: Partial<T>) =>
        setGroupPayState((cur: IGroupPayState) => {
          return { ...cur, ...newState };
        }),
      [StateType.OrderComplete]: (newState: Partial<T>) =>
        setOrderCompletePopup((cur: IOrderComplete) => {
          return { ...cur, ...newState };
        }),
    };

    states[type](newState);
  }

  useEffect(() => {
    const source = axios.CancelToken.source();
    if (addItemState?.greenFeeActive || addItemState?.powerCartFeeActive) {
      void openSelectParticipantFee(addItemState?.selectedSlot, addItemState?.selectedProductType, source.token);
    }
    return () => {
      source.cancel();
    };
  }, [addItemState?.greenFeeActive, addItemState?.powerCartFeeActive]);

  useEffect(() => {
    let mounted = true;
    let timeoutId: NodeJS.Timeout = null;
    if (mounted === true) {
      timeoutId = global.setTimeout(() => {
        void changePlayerSearch(mounted, changePlayerState.customerQuery);
      }, 500);
    }
    return () => {
      mounted = false;
      clearTimeout(timeoutId);
      setChangePlayerState(prevState => ({ ...prevState, playerSearchResult: [] }));
    };
  }, [changePlayerState.customerQuery]);

  useEffect(() => {
    if (!uiStore.editBookingActive) {
      updateState<IMainState>({ teeTimeLock: false }, StateType.MainState);
    }
  }, [uiStore.editBookingActive]);

  useEffect(() => {
    if (checkInState?.order) {
      //Check in players once order is completed
      if (checkInState?.order?.balance <= 0 || checkInState?.order?.financial_status === "paid") {
        void handleCheckParticipants(checkInState?.order);
      }
    }
  }, [checkInState?.order]);

  async function handleEditBooking(booking: IBooking, newPlayerAdded?: boolean) {
    const teeTime = teeSheetStore?.selectedTeeTime;
    // Show edit booking modal while data is loading
    dispatch(initiateEditBooking());

    // Load booking
    updateEditBookingModal({
      isOpen: true,
      loading: true,
      cartsAvailable: {
        nineHole: 0,
        eighteenHole: 0,
      },
    });

    let cartsAvailable9 = 0;
    let cartsAvailable18 = 0;

    if (facilityStore.teeSheetSettings?.validate_power_cart_count) {
      updateEditBookingModal({ loadingText: t("Loading Tee Time Carts Availability...") });

      const cartAvailableRes = await GetTeeTimeCartsAvailable({ tee_time_id: teeTime.id }, false);

      if (cartAvailableRes.status !== StatusCode.OK) {
        dispatch(showError(t("Error loading tee time carts availability")));
        return;
      }

      cartsAvailable9 = cartAvailableRes.data.carts_available_9 ?? 0;
      cartsAvailable18 = cartAvailableRes.data.carts_available_18 ?? 0;
    }

    updateEditBookingModal({
      loadingText: t("secure.facility.tee_sheet.tee_sheet_booking_details.199"),
    });

    const bookingRes = await GetBooking({ id: booking?.id }, false);

    //Check if selected booking has been cancelled by another user
    if (bookingRes.status !== StatusCode.OK || bookingRes.data[0]?.status === "cancelled") {
      void refreshTeeTime(true, true);
      dispatch(showError(t("Booking has been cancelled by another user")));
      return;
    }

    updateEditBookingModal({
      loadingText: t("secure.facility.tee_sheet.tee_sheet_booking_details.200"),
      postingLock: true,
    });

    const postLockRes = await PostTeeTimeLock({ tee_time_id: teeTime?.id }, false);
    if (postLockRes.status !== StatusCode.OK) {
      return;
    }

    // Tee time is locked by another user
    if (postLockRes.status !== StatusCode.OK) {
      updateEditBookingModal({
        selectedBooking: null,
        selectedTeeTime: null,
        loading: false,
        postingLock: false,
        teeTimeLock: false,
      });
      dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.005")));
    }

    updateEditBookingModal({
      selectedBooking: {
        ...bookingRes.data[0],
        quantity: newPlayerAdded ? (bookingRes.data[0].quantity += 1) : bookingRes.data[0].quantity,
      },
      cartsAvailable: {
        nineHole: cartsAvailable9,
        eighteenHole: cartsAvailable18,
      },
      selectedTeeTime: teeTime,
      loading: false,
      postingLock: false,
    });
  }

  async function handleRemoveFee(
    slot: ISlot,
    variantId: number,
    type: "green_fee" | "power_cart_fee",
    event: React.MouseEvent<Element, MouseEvent>,
  ) {
    if (event) {
      event.stopPropagation();
    }

    let currentParticipant = [...participantPaidFees.current]?.find(
      participant => participant?.booking_participant_id === slot?.booking_participant?.id,
    );

    if (
      (checkInState?.cart && type === "green_fee" && currentParticipant?.green_fee) ||
      (type === "power_cart_fee" && currentParticipant?.power_cart_fee)
    ) {
      //Find line item with matching variant id in cart
      const foundItem = [...checkInState.cart.line_items]?.find(
        lineItem =>
          lineItem.variant_id === variantId &&
          !lineItemsUpdating?.current?.some(updatingItem => updatingItem?.id === lineItem?.id),
      );
      if (foundItem) {
        currentParticipant = { ...currentParticipant, [`${type}_loading`]: true };
        void updateParticipantPaidFees(currentParticipant);
        void addLineItemUpdating(foundItem?.id, "delete");
        updateState<IOrderProgess>({ orderStep: OrderProgress.ADDING_FEES }, StateType.OrderProgress);
        let updateRes;
        //Decrement line item quantity if quantity > 1
        if (foundItem?.quantity > 1) {
          updateRes = await PutLineItemToCart({ id: foundItem?.id, quantity: foundItem?.quantity - 1 }, false);
        } else {
          //Remove line item if line item quantity is 1
          updateRes = await DeleteLineItemToCart({ id: foundItem?.id }, false);
        }

        currentParticipant = [...participantPaidFees.current]?.find(
          participant => participant?.booking_participant_id === slot?.booking_participant?.id,
        );
        if (updateRes?.status !== StatusCode.OK) {
          dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.201")));
          currentParticipant = { ...currentParticipant, [`${type}_loading`]: false };
        } else {
          //Set fee & loading status to false
          currentParticipant = { ...currentParticipant, [`${type}`]: false, [`${type}_loading`]: false };
          updateState<ICheckInState>({ cart: updateRes?.data }, StateType.CheckInState);
        }
        void removeLineItemUpdating(foundItem?.id);
      } else {
        //Item not found, still set fee value to false
        currentParticipant = { ...currentParticipant, [`${type}`]: false, [`${type}_loading`]: false };
      }
      void updateParticipantPaidFees(currentParticipant);
      updateState<IOrderProgess>({ orderStep: OrderProgress.ORDER_IN_PROGRESS }, StateType.OrderProgress);
    }
  }

  async function handleAddFee(
    slot: ISlot,
    greenFee: { id: number; productTitle: string; variantTitle: string } | null,
    powerCartFee: { id: number; productTitle: string; variantTitle: string } | null,
    event?: React.MouseEvent<Element, MouseEvent>,
    defaultCart: ICart | null = null,
  ) {
    if (event) {
      event.stopPropagation();
    }
    //Return to cart page if a product is added when the payment methods page is displayed
    if (registerState?.page === null) {
      updateRegisterState({ page: "cart" });
    }

    let currentParticipant = [...participantPaidFees.current]?.find(
      participant => participant?.booking_participant_id === slot?.booking_participant?.id,
    );

    if (!currentParticipant) {
      //Participant not found, add to the array
      const newParticipant = {
        booking_participant_id: slot?.booking_participant?.id,
        green_fee: slot?.booking_participant?.green_fee_paid,
        power_cart_fee: slot?.booking_participant?.power_cart_paid,
        green_fee_loading: false,
        power_cart_fee_loading: false,
      };
      const currentFees = [...participantPaidFees.current, newParticipant];
      void initializeParticipantPaidFees(currentFees);
      currentParticipant = newParticipant;
    }

    if (currentParticipant) {
      //Arrow >> button is clicked but both the green fee product and power cart fee product aren't set
      if (
        greenFee &&
        powerCartFee &&
        !slot?.booking_participant?.green_fee_variant_id &&
        !slot?.booking_participant?.power_cart_variant_id
      ) {
        dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.202")));
        return;
      }
      let cart = checkInState?.cart ? checkInState?.cart : defaultCart ? defaultCart : null;
      const variants = [];

      //Set green fee variant & show green fee loader
      if (
        greenFee &&
        !currentParticipant?.green_fee &&
        greenFee?.id !== null &&
        greenFee?.id !== undefined &&
        !slot?.booking_participant?.green_fee_paid
      ) {
        variants.push({
          variant_id: greenFee?.id,
          quantity: 1,
          title: greenFee?.variantTitle,
          product_title: greenFee?.productTitle,
          tee_time_booking_id: state.applyDynamicPricing ? slot.tee_time_booking_id : null,
          price: slot?.booking_participant?.green_fee_price,
        });
        currentParticipant = { ...currentParticipant, green_fee: true, green_fee_loading: true };
        void updateParticipantPaidFees(currentParticipant);
      }

      //Set power cart variant & show power cart loader
      if (
        powerCartFee &&
        !currentParticipant?.power_cart_fee &&
        powerCartFee?.id !== null &&
        powerCartFee?.id !== undefined &&
        !slot?.booking_participant?.power_cart_paid
      ) {
        variants.push({
          variant_id: powerCartFee?.id,
          quantity: 1,
          title: powerCartFee?.variantTitle,
          product_title: powerCartFee?.productTitle,
          price: slot?.booking_participant?.power_cart_price,
        });
        currentParticipant = { ...currentParticipant, power_cart_fee: true, power_cart_fee_loading: true };
        void updateParticipantPaidFees(currentParticipant);
      }

      //Create a cart if one is not in state
      if (
        (!cart || (orderProgress.orderStep === OrderProgress.NEW_ORDER && defaultCart === null)) &&
        variants?.length > 0
      ) {
        updateState<IOrderProgess>({ orderStep: OrderProgress.CREATING_CART }, StateType.OrderProgress);
        const postCartRes = await PostCart(
          { customer_id: !slot.booking_participant?.guest ? slot.booking_participant.customer_id : null },
          false,
        );
        if (postCartRes?.status !== StatusCode.OK) {
          dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.203")));
          void updateParticipantPaidFees({
            ...currentParticipant,
            power_cart_fee: false,
            green_fee: false,
            green_fee_loading: false,
            power_cart_fee_loading: false,
          });
          updateState<IOrderProgess>({ orderStep: OrderProgress.NEW_ORDER }, StateType.OrderProgress);
          return;
        }
        cart = postCartRes?.data;
        // Save cart to state
        updateState<ICheckInState>({ cart: postCartRes?.data, order: undefined }, StateType.CheckInState);
      }

      //Adding customer back to the cart

      if (cart && !cart.customer_id && !slot.booking_participant.guest) {
        const putCartRes = await PutCart(
          { id: cart.id, customer_id: !slot.booking_participant?.guest ? slot.booking_participant.customer_id : null },
          false,
        );

        if (putCartRes?.status !== StatusCode.OK) {
          dispatch(showError(t("Error adding customer to cart")));
          updateState<IOrderProgess>({ orderStep: OrderProgress.NEW_ORDER }, StateType.OrderProgress);
          return;
        }

        cart = putCartRes?.data;
        // Save cart to state
        updateState<ICheckInState>({ cart: putCartRes?.data }, StateType.CheckInState);
      }

      //Add variant(s) to cart
      if (variants?.length > 0) {
        //Display loading variants in cart
        variants?.forEach(variant => {
          void addLoadingVariant(
            { id: variant?.variant_id, title: variant?.title, quantity: variant?.quantity } as IVariant,
            { title: variant?.product_title } as IProduct,
          );
        });

        updateState<IOrderProgess>({ orderStep: OrderProgress.ADDING_FEES }, StateType.OrderProgress);
        const lineItemRes = await PostLineItemToCart(
          {
            cart_id: cart?.id,
            variants: variants,
            line_items_stack: false,
          },
          false,
        );
        //Remove loading variants in cart
        variants?.forEach(variant => {
          void removeLoadingVariant(variant?.variant_id);
        });
        if (lineItemRes?.status !== StatusCode.OK) {
          dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.204")));
          void updateParticipantPaidFees({
            ...currentParticipant,
            green_fee: greenFee ? false : currentParticipant?.green_fee,
            power_cart_fee: powerCartFee ? false : currentParticipant?.power_cart_fee,
            green_fee_loading: false,
            power_cart_fee_loading: false,
          });
          return;
        }

        currentParticipant = [...participantPaidFees.current]?.find(
          participant => participant?.booking_participant_id === slot?.booking_participant?.id,
        );
        //Remove loader on green fee / power cart fee
        if (greenFee && currentParticipant) {
          currentParticipant = { ...currentParticipant, green_fee_loading: false };
          void updateParticipantPaidFees(currentParticipant);
        }
        if (powerCartFee && currentParticipant) {
          currentParticipant = { ...currentParticipant, power_cart_fee_loading: false };
          void updateParticipantPaidFees(currentParticipant);
        }

        ReactDOM.unstable_batchedUpdates(() => {
          updateState<ICheckInState>({ cart: lineItemRes?.data }, StateType.CheckInState);
          updateState<IOrderProgess>({ orderStep: OrderProgress.ORDER_IN_PROGRESS }, StateType.OrderProgress);
        });
      }

      return cart;
    }
  }

  async function addRedemptionItemVariantsToCart(
    variants: Array<{ variant_id: number; quantity: number }>,
  ): Promise<boolean> {
    if (!variants.length) {
      return false;
    }

    const slot =
      teeSheetStore?.selectedTeeTime?.slots?.find(
        teeSheetSlot => teeSheetSlot?.booking_participant?.id === addItemState?.participant_id,
      ) ?? teeSheetStore?.selectedTeeTime?.slots?.[0];

    let cart = checkInState?.cart ?? null;

    if (registerState?.page === null) {
      updateRegisterState({ page: "cart" });
    }

    if (!cart || orderProgress.orderStep === OrderProgress.NEW_ORDER) {
      updateState<IOrderProgess>({ orderStep: OrderProgress.CREATING_CART }, StateType.OrderProgress);
      const postCartRes = await PostCart(
        {
          customer_id: slot?.booking_participant?.guest ? null : slot?.booking_participant?.customer_id ?? null,
        },
        false,
      );

      if (postCartRes?.status !== StatusCode.OK) {
        dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.203")));
        updateState<IOrderProgess>({ orderStep: OrderProgress.NEW_ORDER }, StateType.OrderProgress);
        return false;
      }

      cart = postCartRes.data;
      updateState<ICheckInState>({ cart: postCartRes.data, order: undefined }, StateType.CheckInState);
    }

    if (cart && !cart.customer_id && slot?.booking_participant && !slot.booking_participant.guest) {
      const putCartRes = await PutCart(
        { id: cart.id, customer_id: slot.booking_participant.customer_id },
        false,
      );

      if (putCartRes?.status !== StatusCode.OK) {
        dispatch(showError(t("Error adding customer to cart")));
        return false;
      }

      cart = putCartRes.data;
      updateState<ICheckInState>({ cart: putCartRes.data }, StateType.CheckInState);
    }

    const lineItemRes = await PostLineItemToCart(
      {
        cart_id: cart?.id,
        variants,
        line_items_stack: false,
      },
      false,
    );

    if (lineItemRes?.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.204")));
      return false;
    }

    updateState<ICheckInState>({ cart: lineItemRes.data }, StateType.CheckInState);
    updateState<IOrderProgess>({ orderStep: OrderProgress.ORDER_IN_PROGRESS }, StateType.OrderProgress);
    return true;
  }

  function openApplyDynamicPricingModal(variant: IVariant) {
    if (addItemState.selectedSlot.booking.dynamic_percent_variation === 0) {
      void handleAddQuickItem(variant, "Green Fee");
      return;
    }

    updateState<IAddItemState>(
      {
        greenFeeActive: false,
      },
      StateType.AddItemState,
    );

    setState(prev => ({
      ...prev,
      applyDynamicPricingModal: true,
      dynamicPricingVariant: variant,
    }));
  }

  function applyDynamicPricing() {
    setState(prev => ({
      ...prev,
      applyDynamicPricing: true,
      applyDynamicPricingModal: false,
    }));
  }

  function closeApplyDynamicPricingModal() {
    setState(prev => ({
      ...prev,
      applyDynamicPricing: false,
      applyDynamicPricingModal: false,
    }));
  }

  useEffect(() => {
    if (state.dynamicPricingVariant !== null && state.applyDynamicPricingModal === false) {
      void handleAddQuickItem(state.dynamicPricingVariant, "Green Fee");
      setState(prev => ({
        ...prev,
        dynamicPricingVariant: null,
      }));
    }
  }, [state.applyDynamicPricingModal]);

  function initiateSelectParticipantFee(
    event: React.MouseEvent<Element, MouseEvent>,
    slot: ISlot,
    product_type: "Green Fee" | "Power Cart",
    green_fee_added?: boolean,
    power_cart_fee_added?: boolean,
    orderStarted?: boolean,
  ) {
    event?.stopPropagation();
    if (
      (green_fee_added && power_cart_fee_added) ||
      (product_type === "Green Fee" && (slot.booking_participant.green_fee_paid || green_fee_added)) ||
      (product_type === "Power Cart" && (slot.booking_participant.power_cart_paid || power_cart_fee_added)) ||
      orderStarted ||
      orderProgress.orderStep === OrderProgress.CREATING_CART
    ) {
      return;
    }
    const active_type = product_type === "Green Fee" ? "greenFeeActive" : "powerCartFeeActive";
    updateState<IAddItemState>(
      {
        [active_type]: true,
        selectedSlot: slot,
        selectedProductType: product_type,
      },
      StateType.AddItemState,
    );
  }

  const openSelectParticipantFee = async (
    slot: ISlot,
    product_type: "Green Fee" | "Power Cart",
    cancelToken?: CancelToken,
  ) => {
    let active_type: string;
    let active_store: any;
    let active_store_string: string;

    if (product_type === "Green Fee") {
      active_type = "greenFeeActive";
      active_store = teeSheetProductStore.greenFeeItems;
      active_store_string = "greenFeeItems";
    }

    if (product_type === "Power Cart") {
      active_type = "powerCartFeeActive";
      active_store = teeSheetProductStore.powerCartItems;
      active_store_string = "powerCartItems";
    }

    let items = active_store;
    if (active_store === null) {
      // Get Products if redux store is empty
      updateState<IAddItemState>(
        {
          participantFeeLoadingMessage: `${t(
            "secure.facility.tee_sheet.tee_sheet_booking_details.205",
          )} ${product_type} ${t("secure.facility.tee_sheet.tee_sheet_booking_details.206")}`,
          [active_type]: true,
        },
        StateType.AddItemState,
      );
      items = await GetProduct({ type: product_type, extended: true }, false, cancelToken);
      updateState<IAddItemState>({ participantFeeLoadingMessage: null }, StateType.AddItemState);
    }

    if (items?.status === StatusCode.OK) {
      const participant_id = slot?.tee_time_booking_participant_id;
      const tee_time_id = slot?.tee_time_id;

      let greenFeeFolderItems: IProduct[] | null = null;
      if (product_type === "Green Fee") {
        let cachedFolderItems = teeSheetProductStore.greenFeeFolderItems;
        const cachedFolderMeta = teeSheetProductStore.greenFeeFolderMeta as {
          folder_id: number | null;
          updated_at: string | null;
        } | null;

        const foldersMetaRes = await GetFolder({ extended: false }, false, cancelToken);
        const greenFeeFolderMeta = foldersMetaRes?.data?.find((folder: any) => folder.type === "green_fee");

        const nextFolderId = greenFeeFolderMeta?.id ?? null;
        const nextUpdatedAt = greenFeeFolderMeta?.updated_at ?? null;
        const isCacheFresh =
          cachedFolderItems !== null &&
          cachedFolderMeta?.folder_id === nextFolderId &&
          cachedFolderMeta?.updated_at === nextUpdatedAt;

        if (!isCacheFresh) {
          if (nextFolderId) {
            const folderRes = await GetFolder({ id: nextFolderId, extended: true }, false, cancelToken);
            const folder = folderRes?.data?.[0];
            cachedFolderItems = folder?.products?.length > 0 ? folder.products : [];
          } else {
            cachedFolderItems = [];
          }

          dispatch(updateTeeSheetProducts("greenFeeFolderItems", cachedFolderItems));
          dispatch(
            updateTeeSheetProducts("greenFeeFolderMeta", { folder_id: nextFolderId, updated_at: nextUpdatedAt }),
          );
        }

        greenFeeFolderItems = cachedFolderItems;
      }

      let powerCartFolderItems: IProduct[] | null = null;
      if (product_type === "Power Cart") {
        let cachedFolderItems = teeSheetProductStore.powerCartFolderItems;
        const cachedFolderMeta = teeSheetProductStore.powerCartFolderMeta as {
          folder_id: number | null;
          updated_at: string | null;
        } | null;

        const foldersMetaRes = await GetFolder({ extended: false }, false, cancelToken);
        const powerCartFolderMeta = foldersMetaRes?.data?.find((folder: any) => folder.type === "power_cart");

        const nextFolderId = powerCartFolderMeta?.id ?? null;
        const nextUpdatedAt = powerCartFolderMeta?.updated_at ?? null;
        const isCacheFresh =
          cachedFolderItems !== null &&
          cachedFolderMeta?.folder_id === nextFolderId &&
          cachedFolderMeta?.updated_at === nextUpdatedAt;

        if (!isCacheFresh) {
          if (nextFolderId) {
            const folderRes = await GetFolder({ id: nextFolderId, extended: true }, false, cancelToken);
            const folder = folderRes?.data?.[0];
            cachedFolderItems = folder?.products?.length > 0 ? folder.products : [];
          } else {
            cachedFolderItems = [];
          }

          dispatch(updateTeeSheetProducts("powerCartFolderItems", cachedFolderItems));
          dispatch(
            updateTeeSheetProducts("powerCartFolderMeta", { folder_id: nextFolderId, updated_at: nextUpdatedAt }),
          );
        }

        powerCartFolderItems = cachedFolderItems;
      }

      updateState<IAddItemState>(
        {
          itemSearchResult: items.data,
          participant_id,
          tee_time_id,
          selectedSlot: slot,
          [active_type]: true,
          ...(product_type === "Green Fee" && { greenFeeFolderItems }),
          ...(product_type === "Power Cart" && { powerCartFolderItems }),
        },
        StateType.AddItemState,
      );
      dispatch(updateTeeSheetProducts(active_store_string, items));
    } else {
      void cancelAddItem();
      if (cancelToken && cancelToken?.reason) {
        return;
      }
      dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.207")));
    }
  };

  const cancelAddItem = () => {
    updateState<IAddItemState>(
      {
        itemSearchResult: [],
        greenFeeActive: false,
        powerCartFeeActive: false,
        participant_id: null,
        tee_time_id: null,
        selectedProductType: null,
        greenFeeFolderItems: null,
        powerCartFolderItems: null,
        productState: {
          selectedProduct: undefined,
          variants: [],
          variantSheetOpen: false,
        },
      },
      StateType.AddItemState,
    );
  };

  async function handleAddQuickItem(variant: IVariant, product_type: "Green Fee" | "Power Cart", product?: IProduct) {
    const addItem = { ...addItemState };
    const participantId = addItem?.participant_id;
    let addToCart = false;

    //Add item to cart if tee time date is today
    if (moment(teeSheetStore?.selectedTeeTime?.date).isSame(moment(), "date")) {
      addToCart = true;
      if (!checkInState?.cart || orderProgress.orderStep === OrderProgress.NEW_ORDER) {
        //Set order progress to disable adding more items until the cart is created
        updateState<IOrderProgess>({ orderStep: OrderProgress.CREATING_CART }, StateType.OrderProgress);
      }
    }

    let green_fee_variant_id;
    let power_cart_variant_id;

    if (product_type === "Green Fee") {
      green_fee_variant_id = variant?.id;
    }

    if (product_type === "Power Cart") {
      power_cart_variant_id = variant?.id;
    }

    //Close and clear modal
    void cancelAddItem();

    let currentParticipant = [...participantPaidFees.current]?.find(
      participant => participant?.booking_participant_id === participantId,
    );

    //Add loader to participant fee
    if (currentParticipant) {
      void updateParticipantPaidFees({
        ...currentParticipant,
        green_fee_loading: product_type === "Green Fee" ? true : currentParticipant?.green_fee_loading,
        power_cart_fee_loading: product_type === "Power Cart" ? true : currentParticipant?.power_cart_fee_loading,
      });
    }
    const putBookingParticipantRes = await PutBookingParticipant(
      { id: participantId, green_fee_variant_id, power_cart_variant_id },
      false,
    );

    currentParticipant = [...participantPaidFees.current]?.find(
      participant => participant?.booking_participant_id === participantId,
    );

    //Remove loader from participant fee
    if (currentParticipant) {
      void updateParticipantPaidFees({
        ...currentParticipant,
        green_fee_loading: product_type === "Green Fee" ? false : currentParticipant?.green_fee_loading,
        power_cart_fee_loading: product_type === "Power Cart" ? false : currentParticipant?.power_cart_fee_loading,
      });
    }

    if (putBookingParticipantRes.status === StatusCode.OK) {
      //If teetime is today, add Fee to cart
      if (addToCart) {
        const productTitle = product
          ? product?.preferred_title
            ? product?.preferred_title
            : product?.title
          : addItem?.productState?.selectedProduct?.preferred_title
          ? addItem?.productState?.selectedProduct?.preferred_title
          : addItem?.productState?.selectedProduct?.title;
        if (product_type === "Power Cart") {
          void handleAddFee(
            {...addItem?.selectedSlot, booking_participant: putBookingParticipantRes?.data},
            null,
            { id: variant?.id, variantTitle: variant?.title, productTitle: productTitle },
            null,
          );
          if (facilityStore?.teeSheetSettings?.track_cart_numbers) {
            updateState<IMainState>({ promptCartNumberSlot: addItem?.selectedSlot }, StateType.MainState);
          }
        } else if (product_type === "Green Fee") {
          void handleAddFee(
            {...addItem?.selectedSlot, booking_participant: putBookingParticipantRes?.data},
            { id: variant?.id, variantTitle: variant?.title, productTitle: productTitle },
            null,
            null,
          );
        }
      }

      // Refresh tee time
      void dispatch(selectTeeTime(addItem?.tee_time_id, false, false));

      // display success message
      dispatch(showSuccess(t("secure.facility.tee_sheet.tee_sheet_booking_details.144")));
    } else {
      currentParticipant = [...participantPaidFees.current]?.find(
        participant => participant?.booking_participant_id === participantId,
      );

      //Remove loader from participant fee
      if (currentParticipant) {
        void updateParticipantPaidFees({
          ...currentParticipant,
          green_fee_loading: product_type === "Green Fee" ? false : currentParticipant?.green_fee_loading,
          power_cart_fee_loading: product_type === "Power Cart" ? false : currentParticipant?.power_cart_fee_loading,
        });
      }
      dispatch(showError(`${t("secure.facility.tee_sheet.tee_sheet_booking_details.208")} ${product_type}`));
    }
  }

  const handleDeleteOrder = () => {
    void resetParticipantFees(teeSheetStore?.selectedTeeTime);
    ReactDOM.unstable_batchedUpdates(() => {
      updateState<ICheckInState>(
        { order: undefined, cart: null },
        StateType.CheckInState,
      );
      updateState<IOrderProgess>({ orderStep: OrderProgress.NEW_ORDER }, StateType.OrderProgress);
      updateState<IMainState>({ clearCartActive: false }, StateType.MainState);
    });
  };

  const closeIssueRainCheck = () => {
    updateState<IRainCheckState>(
      { rainCheckActive: false, selectedBookingParticipantId: null },
      StateType.RainCheckState,
    );
  };

  const closeRedeemRainCheck = () => {
    updateState<IRainCheckState>({ redeemRainCheckActive: false, redeemRainCheckCode: "" }, StateType.RainCheckState);
  };

  const handleRedeemRainCheck = async (codeRainChecks: string, rainCheckID: number) => {
    //Return to cart page if a product is added when the payment methods page is displayed
    if (registerState?.page === null) {
      updateRegisterState({ page: "cart" });
    }
    if (checkInState.cart?.id) {
      const redeemRes = await PostRedeemRainCheck(
        {
          cart_id: checkInState.cart.id,
          rain_check_code: codeRainChecks ?? undefined,
          rain_check_id: rainCheckID ?? undefined,
        },
        true,
      );
      if (redeemRes.status !== StatusCode.OK) {
        dispatch(showError(redeemRes.data as string));
        return;
      }
      dispatch(showSuccess(t("secure.facility.tee_sheet.tee_sheet_booking_details.181")));
      updateState<ICheckInState>({ cart: redeemRes.data }, StateType.CheckInState);
      closeRedeemRainCheck();
    } else {
      return;
    }
  };

  const handleNoShowCheckbox = (selectedId: number) => {
    const foundIndex = noShow.bookingParticipantIds.indexOf(selectedId);

    if (foundIndex === -1) {
      updateState<INoShowState>(
        {
          bookingParticipantIds: [...noShow.bookingParticipantIds, selectedId],
          quantity: noShow.quantity + 1,
        },
        StateType.NoShowState,
      );
    } else {
      updateState<INoShowState>(
        {
          bookingParticipantIds: noShow.bookingParticipantIds.filter(val => val !== selectedId),
          quantity: noShow.quantity - 1,
        },
        StateType.NoShowState,
      );
    }
  };

  const handleNoShowDropDownChange = (value: any, extraValues: any) => {
    updateState<INoShowState>(
      { greenFeeProductID: value, greenFeeProductTitle: extraValues.title, greenFeeProductPrice: extraValues.price },
      StateType.NoShowState,
    );
  };

  async function handleRemoveNoShowBooking(slot: ISlot) {
    const res = await PutBookingParticipantRemoveNoShow({ id: slot.booking_participant.id }, true);
    if (res.status !== StatusCode.OK) {
      dispatch(showError(t("Remove No Show failed")));
      return;
    }
    dispatch(showSuccess(t("Successfully removed no show")));
    void refreshTeeTime(false, true);
  }

  //Get customer's Stripe payment method id
  const handleCustomerPaymentMethod = async (slot: ISlot) => {
    if (slot?.booking?.customer_payment_method_id === null || slot?.booking?.customer_id === null) {
      updateState<INoShowState>({ paymentMethodID: null }, StateType.NoShowState);
      return false;
    }
    const paymentMethodRes = await GetCustomerPaymentMethod(
      { id: slot?.booking?.customer_payment_method_id, customer_id: slot?.booking?.customer_id },
      true,
    );

    if (paymentMethodRes.data.length > 0) {
      updateState<INoShowState>(
        { paymentMethodID: paymentMethodRes.data[0].stripe_payment_method_id },
        StateType.NoShowState,
      );
    }
    return true;
  };

  // Confirm Stripe payment intent
  const confirmCardPaymentNoShow = async (
    clientSecret: string,
    paymentMethodID: string,
    trans_id: number,
    orderId: number,
  ) => {
    if (!stripe) {
      return;
    }

    dispatch(enqueue());
    const { error: stripeError, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
      payment_method: paymentMethodID,
    });
    dispatch(dequeue());

    if (stripeError) {
      dispatch(showError(stripeError.message));
      return;
    }

    //Capture the payment
    const captureRes = await PutCapture({ payment_intent_id: paymentIntent.id, transaction_id: trans_id }, true);

    if (captureRes.status !== StatusCode.OK) {
      dispatch(showError(captureRes.message));
      return;
    }

    for (const bookingParticipantId of noShow.bookingParticipantIds) {
      const putCustomerRes = await PutBookingParticipant(
        { id: bookingParticipantId, no_show_paid: true, order_id: orderId },
        true,
      );
      if (putCustomerRes.status !== StatusCode.OK) {
        dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.150")));
      }
    }

    const participantIdsToEmail = noShow.bookingParticipantIds.filter(participantId => {
      const slot = teeSheetStore?.selectedTeeTime?.slots?.find(
        s => s.booking_participant?.id === participantId || s.tee_time_booking_participant_id === participantId,
      );
      const noShowEmail = slot?.booking_participant?.no_show_email;
      return Boolean(noShowEmail);
    });

    if (participantIdsToEmail.length > 0) {
      const noshowEmailRes = await PostNoShowEmail({ participant_ids: participantIdsToEmail }, false);
      if (noshowEmailRes.status !== StatusCode.OK) {
        dispatch(showError(t(noshowEmailRes.message ?? "Error sending no show charge email.")));
      }
    }

    void dispatch(selectTeeTime(parseInt(teetimeId), true));
    dispatch(showSuccess(t("secure.facility.tee_sheet.tee_sheet_booking_details.170")));
    updateState<INoShowState>(
      { noShowActive: false, bookingParticipantIds: [], quantity: 0, paymentMethodID: null },
      StateType.NoShowState,
    );
  };

  //Charging the customer for no show is handled here
  const handleNoShowCharge = () => {
    if (noShow.quantity === 0 || noShow.greenFeeProductID === null || noShow.customerID === null) {
      return;
    }

    void (async () => {
      try {
        //Create order
        const postOrderRes = await PostOrder({ customer_id: noShow.customerID }, true);
        if (postOrderRes.status === StatusCode.OK) {
          try {
            //Create line item order
            const postLineItemOrderRes = await PostLineItemsToOrder(
              {
                order_id: postOrderRes.data.id,
                variant_id: noShow.greenFeeProductID,
                quantity: noShow.quantity,
              },
              true,
            );
            if (postLineItemOrderRes.status === StatusCode.OK) {
              try {
                //Create transaction
                const postTransactionRes = await PostTransaction(
                  {
                    kind: "sale",
                    amount: postLineItemOrderRes.data.total_price,
                    order_id: postOrderRes.data.id,
                    payment_option_id: facilityStore.paymentOptions?.find(
                      paymentOption => paymentOption.payment_method === "manual_card",
                    )?.id,
                  },
                  true,
                );
                if (postTransactionRes.status === StatusCode.OK) {
                  //Confirm the payment intent after succesfully creating a transaction
                  void confirmCardPaymentNoShow(
                    postTransactionRes.data.client_secret,
                    noShow.paymentMethodID,
                    postTransactionRes.data.id,
                    Number(postOrderRes.data.id),
                  );
                } else {
                  dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.007")));
                  return;
                }
              } catch (e) {
                dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.007")));
                console.log(e);
              }
            }
          } catch (e) {
            dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.008")));
            console.log(e);
          }
        }
      } catch (e) {
        dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.009")));
        console.log(e);
      }
      const postAuditRes = await PostNoShowChargeAudit({ participant_id: noShow.customerID }, true);

      if (postAuditRes.status !== StatusCode.OK) {
        dispatch(showError(t("Error while posting no show charge audit")));
      }
    })();
  };

  const handleCancelBookingParticipant = async (slot: ISlot) => {
    try {
      const putCancelRes = await PutCancelParticipant({ id: slot.booking_participant.id }, true);

      if (putCancelRes.status === StatusCode.OK) {
        void dispatch(selectTeeTime(parseInt(teetimeId), true));
        dispatch(showSuccess(t("secure.facility.tee_sheet.tee_sheet_booking_details.210")));
      }

      if (putCancelRes.status !== StatusCode.OK) {
        dispatch(showError(errorMessage(putCancelRes, t("Error cancelling player"))));
      }
    } catch (e) {
      console.log(e);
    }
  };

  async function handleAllNoShowBookingParticipants(
    type: "charge" | "defer" | "weather",
    allSlotIds: number[],
    email: boolean = false,
  ) {
    const responses = await Promise.all(
      allSlotIds.map(id => PutBookingParticipantNoShow({ id, no_show_type: type, sendEmail: email }, true)),
    );
    if (responses?.some(res => res?.status !== StatusCode.OK)) {
      const foundResponse = responses?.find(res => res?.status !== StatusCode.OK);
      if (foundResponse) {
        void dispatch(
          showError(
            typeof foundResponse?.data === "string"
              ? foundResponse?.data
              : t("secure.facility.tee_sheet.tee_sheet_booking_details.139") + type.replace(/_/g, " "),
          ),
        );
      }
      return;
    }

    void dispatch(selectTeeTime(parseInt(teetimeId), true)); //refreshes the page
    void dispatch(showSuccess(t("secure.facility.tee_sheet.tee_sheet_booking_details.010") + type.replace(/_/g, " ")));
  }

  const handleNoShowBookingParticipant = async (
    slot: ISlot,
    type: "charge" | "defer" | "weather",
    allSlotIds: Array<number>,
    email: boolean = false,
  ) => {
    const id = slot.tee_time_booking_participant_id;

    // Set no show for all participants if allSlotIds is passed
    if (allSlotIds) {
      await handleAllNoShowBookingParticipants(type, allSlotIds, email);
      return;
    }

    try {
      const putBookingParticipantRes = await PutBookingParticipantNoShow(
        {
          id,
          no_show_type: type,
          sendEmail: email,
        },
        true,
      );

      if (putBookingParticipantRes.status === StatusCode.OK) {
        void dispatch(selectTeeTime(parseInt(teetimeId), true)); //refreshes the page
        dispatch(showSuccess(t("secure.facility.tee_sheet.tee_sheet_booking_details.010") + type.replace(/_/g, " ")));
      } else {
        dispatch(
          showError(
            typeof putBookingParticipantRes?.data === "string"
              ? putBookingParticipantRes?.data
              : t("secure.facility.tee_sheet.tee_sheet_booking_details.139") + type.replace(/_/g, " "),
          ),
        );
      }
    } catch (e) {
      console.log("handleNoShow ERR:", e);
    }
  };

  async function handleManualCheckIn() {
    const checkInRes = await PutBookingParticipant(
      {
        id: checkInState.manualCheckInSlot.booking_participant.id,
        check_in_status: "checked",
      },
      true,
    );

    if (checkInRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.173")));
    }

    updateState<ICheckInState>(
      {
        manualCheckInVisible: false,
        manualCheckInSlot: null,
      },
      StateType.CheckInState,
    );

    void refreshTeeTime();
  }

  async function handleChargeNoShowModal(slot: ISlot) {
    //Get customer's payment method
    const paymentMethodOnBooking = await handleCustomerPaymentMethod(slot);
    if (!paymentMethodOnBooking) {
      updateState<INoShowState>(
        {
          noPaymentMethodModal: true,
        },
        StateType.NoShowState,
      );
      return;
    }
    if (noShow.greenFeeProducts?.length === 0) {
      void (await loadGreenFeeProducts());
    }

    updateState<INoShowState>(
      {
        noShowActive: true,
        teeTimeBookingId: slot.booking_participant.tee_time_booking_id,
        customerID: slot.booking.customer_id,
      },
      StateType.NoShowState,
    );
    void dispatch(loadPaymentOptions());
  }

  const handleInitiateRedeemTicket = async (slot: ISlot) => {
    const participant_id = slot.tee_time_booking_participant_id;

    const ticketRes = await GetTicketStub(
      {
        customer_id: slot.booking_participant.customer_id,
        status: "valid",
        extended: true,
        valid_facilities: true,
        shared: true,
        redemption_products: true,
        limit: TICKET_LIMIT,
        offset: 0,
      },
      true,
    );

    ReactDOM.unstable_batchedUpdates(() => {
      updateState<IMainState>({ selectedBooking: slot?.booking }, StateType.MainState);
      updateState<ICheckInState>(
        {
          redeemTicketActive: true,
          availableTickets: ticketRes.data,
          availableTicketsOffset: 0,
          ticketCustomerId: slot?.booking_participant?.customer_id,
          redeemTicketSelected: ticketRes?.data?.length > 0 ? 1 : 0,
          ticketParticipantId: slot?.booking_participant?.id,
          ticketPendingStubIds: slot?.booking_participant?.pending_ticket_stub_ids,
        },
        StateType.CheckInState,
      );
      updateState<IAddItemState>({ participant_id }, StateType.AddItemState);
    });
  };

  const handleAvailableTicketsOffset = async (direction: "prev" | "next") => {
    if (!checkInState.ticketCustomerId) {
      return;
    }
    const newOffset =
      direction === "prev"
        ? checkInState.availableTicketsOffset - TICKET_LIMIT
        : checkInState.availableTicketsOffset + TICKET_LIMIT;
    if (newOffset < 0) {
      return;
    }
    const ticketRes = await GetTicketStub(
      {
        customer_id: checkInState.ticketCustomerId,
        status: "valid",
        extended: true,
        valid_facilities: true,
        shared: true,
        redemption_products: true,
        limit: TICKET_LIMIT,
        offset: newOffset,
      },
      true,
    );
    if (ticketRes.status === StatusCode.OK) {
      updateState<ICheckInState>(
        {
          availableTickets: ticketRes.data,
          availableTicketsOffset: newOffset,
        },
        StateType.CheckInState,
      );
    }
  };

  const handleSearchTicket = async () => {
    let tickets: IStub[] = [];
    let ticketQuantities: TicketRedemptionQuantityMap = {};
    let ticket_stub_ids: number[] = [];

    // Use searched for codes
    if (checkInState.redeemTicketSelected === 0) {
      tickets = checkInState.selectedTickets?.filter(ticket => ticket.status === "valid") ?? [];
      ticketQuantities = checkInState.selectedTicketQuantities;
      ticket_stub_ids = expandTicketStubIds(tickets, ticketQuantities);
    }

    // Use customer codes
    if (checkInState.redeemTicketSelected === 1) {
      tickets = checkInState.selectedCustomerTickets?.filter(ticket => ticket.status === "valid") ?? [];
      ticketQuantities = checkInState.selectedCustomerTicketQuantities;
      ticket_stub_ids = expandTicketStubIds(tickets, ticketQuantities);
    }

    if (tickets.length > 1 && checkInState.redeemTicketSelected === 1) {
      void handleRedeemMultipleTickets();
      return;
    }

    if (tickets.length === 1 && isMultiUseTicket(tickets[0])) {
      void handleRedeemMultiUseTicketAssignment(
        tickets[0],
        getTicketRedemptionQuantity(tickets[0].id, ticketQuantities),
      );
      return;
    }

    if (ticket_stub_ids.length < 1) {
      dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.211")));
      return;
    }

    const selectedBookingParticipantIndex = teeSheetStore?.selectedTeeTime?.slots?.findIndex(
      slot => slot?.booking_participant?.id == addItemState?.participant_id,
    );

    const redeemedStubs = tickets;

    const bookingSlots = [...teeSheetStore.selectedTeeTime.slots];
    //Order the slots so that the next participant after the current one has the ticket applied, then continue from the first participant in the booking
    const slotsOrderUpdate = [
      ...bookingSlots.slice(selectedBookingParticipantIndex, bookingSlots?.length),
      ...bookingSlots.slice(0, selectedBookingParticipantIndex),
    ];

    //Filter out participants whose green fees are already paid (booking-fee-only still eligible)
    const filteredSlots = slotsOrderUpdate?.filter(slot =>
      isSlotEligibleForTicketFeeRedemption(slot, state.selectedBooking?.id),
    );

    //Set the participant ids in an array
    const participantIds = filteredSlots?.map(slot => slot?.booking_participant?.id);

    if (tickets.length === 1 && isMultiUseTicket(tickets[0])) {
      const effectiveQuantity = getRedemptionUseCount(
        tickets[0],
        ticketQuantities,
        participantIds?.length ?? 0,
      );
      ticket_stub_ids = Array.from({ length: effectiveQuantity }, () => tickets[0].id);
    }

    let cartProductsAdded = false;
    let cart = checkInState?.cart ? checkInState?.cart : null;

    dispatch(enqueue());
    for (let i = 0; i < redeemedStubs.length; i++) {
      const stub = redeemedStubs[i];
      const greenFeeProduct = stub?.redemption_product?.green_fee || null;
      const powerCartProduct = stub?.redemption_product?.power_cart || null;

      const greenFeeQuantity = Number(greenFeeProduct?.pivot?.quantity);
      const powerCartQuantity = Number(powerCartProduct?.pivot?.quantity);
      const redemptionUseCount = getRedemptionUseCount(stub, ticketQuantities, participantIds?.length ?? 0);
      const { greenFeeItem, powerCartItem } = getRedemptionItemSlots(stub);
      const itemQuantity = Number(greenFeeItem?.pivot?.quantity);
      const secondaryItemQuantity = Number(powerCartItem?.pivot?.quantity);
      const hasFeeProducts = stubHasFeeRedemptionProducts(stub);
      const hasItemProducts = stubHasItemRedemptionProducts(stub);

      if (
        ((greenFeeProduct && greenFeeQuantity >= 1) || (powerCartProduct && powerCartQuantity >= 1)) &&
        participantIds?.length > 0
      ) {
        const higherQuantity = isMultiUseTicket(stub)
          ? redemptionUseCount
          : greenFeeQuantity && powerCartQuantity
          ? Math.max(greenFeeQuantity, powerCartQuantity)
          : greenFeeQuantity
          ? greenFeeQuantity
          : powerCartQuantity;

        let currentGreenFeeAmount = greenFeeQuantity;
        let currentPowerCartAmount = powerCartQuantity;

        for (const iteration of [...Array(higherQuantity).keys()]) {
          const putBookingParticipantRes = await PutBookingParticipant(
            {
              id: participantIds[0],
              green_fee_variant_id:
                greenFeeProduct && currentGreenFeeAmount >= 1 ? greenFeeProduct?.pivot?.variant_id : undefined,
              power_cart_variant_id:
                powerCartProduct && currentPowerCartAmount >= 1 ? powerCartProduct?.pivot?.variant_id : undefined,
            },
            false,
          );

          if (putBookingParticipantRes.status !== StatusCode.OK) {
            dispatch(dequeue());
            dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.182")));
            return;
          }

          const currentSlot = bookingSlots.find(slot => slot.booking_participant.id === participantIds[0]);
          //Use the participant returned from the update so the redemption product's price is sent to the cart
          const currentParticipant = currentSlot
            ? { ...currentSlot, booking_participant: putBookingParticipantRes?.data }
            : currentSlot;
          let greenFeeRedemptionProduct = null;
          if (putBookingParticipantRes?.data.green_fee_variant_id !== null) {
            greenFeeRedemptionProduct = {
              id:
                greenFeeProduct && currentGreenFeeAmount >= 1
                  ? putBookingParticipantRes?.data?.green_fee_variant_id
                  : undefined,
              variantTitle:
                greenFeeProduct && currentGreenFeeAmount >= 1
                  ? putBookingParticipantRes?.data?.green_fee_variant_title
                  : undefined,
              productTitle:
                greenFeeProduct && currentGreenFeeAmount >= 1
                  ? putBookingParticipantRes?.data?.green_fee_product_title
                  : undefined,
            };
          }

          let powerCartRedemptionProduct = null;
          if (powerCartProduct) {
            powerCartRedemptionProduct = {
              id:
                powerCartProduct && currentPowerCartAmount >= 1
                  ? putBookingParticipantRes?.data?.power_cart_variant_id
                  : undefined,
              variantTitle:
                powerCartProduct && currentPowerCartAmount >= 1
                  ? putBookingParticipantRes?.data?.power_cart_variant_title
                  : undefined,
              productTitle:
                powerCartProduct && currentPowerCartAmount >= 1
                  ? putBookingParticipantRes?.data?.power_cart_product_title
                  : undefined,
            };
          }

          cart = await handleAddFee(currentParticipant, greenFeeRedemptionProduct, powerCartRedemptionProduct, null, cart);
          cartProductsAdded = true;

          //Remove the first booking participant in the array to move onto the next participant
          participantIds.shift();
          //Decrement the green fee / power cart quantity
          currentGreenFeeAmount -= 1;
          currentPowerCartAmount -= 1;
          //If the max quantity between the green fee / power cart is reached or there are no participants left to apply the ticket,
          //break out of the loop and redeem the ticket and close the modal
          if (iteration === higherQuantity - 1 || participantIds?.length === 0) {
            break;
          }
        }
      } else if (hasItemProducts && greenFeeItem && itemQuantity >= 1 && participantIds?.length > 0) {
        const assignmentCount = getParticipantRedemptionAssignmentCount(
          stub,
          ticketQuantities,
          participantIds.length,
        );
        const higherQuantity = isMultiUseTicket(stub) ? assignmentCount : itemQuantity;

        let currentGreenFeeAmount = itemQuantity;
        let currentPowerCartAmount = secondaryItemQuantity;

        for (const iteration of [...Array(higherQuantity).keys()]) {
          const putBookingParticipantRes = await PutBookingParticipant(
            {
              id: participantIds[0],
              green_fee_variant_id:
                greenFeeItem && currentGreenFeeAmount >= 1 ? greenFeeItem?.pivot?.variant_id : undefined,
              power_cart_variant_id:
                powerCartItem && currentPowerCartAmount >= 1 ? powerCartItem?.pivot?.variant_id : undefined,
            },
            false,
          );

          if (putBookingParticipantRes.status !== StatusCode.OK) {
            dispatch(dequeue());
            dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.182")));
            return;
          }

          const currentSlot = bookingSlots.find(slot => slot.booking_participant.id === participantIds[0]);
          const currentParticipant = currentSlot
            ? { ...currentSlot, booking_participant: putBookingParticipantRes?.data }
            : currentSlot;

          let greenFeeRedemptionProduct = null;
          if (putBookingParticipantRes?.data.green_fee_variant_id !== null) {
            greenFeeRedemptionProduct = {
              id:
                greenFeeItem && currentGreenFeeAmount >= 1
                  ? putBookingParticipantRes?.data?.green_fee_variant_id
                  : undefined,
              variantTitle:
                greenFeeItem && currentGreenFeeAmount >= 1
                  ? putBookingParticipantRes?.data?.green_fee_variant_title
                  : undefined,
              productTitle:
                greenFeeItem && currentGreenFeeAmount >= 1
                  ? putBookingParticipantRes?.data?.green_fee_product_title
                  : undefined,
            };
          }

          let powerCartRedemptionProduct = null;
          if (powerCartItem) {
            powerCartRedemptionProduct = {
              id:
                powerCartItem && currentPowerCartAmount >= 1
                  ? putBookingParticipantRes?.data?.power_cart_variant_id
                  : undefined,
              variantTitle:
                powerCartItem && currentPowerCartAmount >= 1
                  ? putBookingParticipantRes?.data?.power_cart_variant_title
                  : undefined,
              productTitle:
                powerCartItem && currentPowerCartAmount >= 1
                  ? putBookingParticipantRes?.data?.power_cart_product_title
                  : undefined,
            };
          }

          cart = await handleAddFee(currentParticipant, greenFeeRedemptionProduct, powerCartRedemptionProduct, null, cart);
          cartProductsAdded = true;

          participantIds.shift();
          currentGreenFeeAmount -= 1;
          currentPowerCartAmount -= 1;

          if (iteration === higherQuantity - 1 || participantIds?.length === 0) {
            break;
          }
        }
      }

      if (hasItemProducts && !hasFeeProducts && participantIds?.length === 0) {
        const itemVariants = buildRedemptionItemVariantsFromStub(stub, redemptionUseCount);
        if (itemVariants.length > 0) {
          const itemsAdded = await addRedemptionItemVariantsToCart(itemVariants);
          if (itemsAdded) {
            cartProductsAdded = true;
          }
        }
      } else if (hasItemProducts && hasFeeProducts) {
        const additionalItemVariants = buildRedemptionItemVariantsFromStub(stub, redemptionUseCount).filter(
          variant =>
            variant.variant_id !== greenFeeProduct?.pivot?.variant_id &&
            variant.variant_id !== powerCartProduct?.pivot?.variant_id,
        );

        if (additionalItemVariants.length > 0) {
          const itemsAdded = await addRedemptionItemVariantsToCart(additionalItemVariants);
          if (itemsAdded) {
            cartProductsAdded = true;
          }
        }
      }
    }

    const hasRedemptionProducts = tickets.some(ticket => stubHasRedemptionProducts(ticket));
    if (hasRedemptionProducts && !cartProductsAdded) {
      dispatch(dequeue());
      dispatch(showError(t("Failed to add redemption products to cart")));
      return;
    }

    dispatch(
      showSuccess(
        `${
          ticket_stub_ids.length > 1
            ? t("secure.facility.tee_sheet.tee_sheet_booking_details.213")
            : t("secure.facility.tee_sheet.tee_sheet_booking_details.214")
        } ${t("secure.facility.tee_sheet.tee_sheet_booking_details.215")}`,
      ),
    );

    if (ticket_stub_ids?.length > 0) {
      const allPendingStubs =
        checkInState?.ticketPendingStubIds && checkInState?.ticketPendingStubIds?.length > 0
          ? [...checkInState.ticketPendingStubIds, ...ticket_stub_ids]
          : ticket_stub_ids;
      const res = await PutBookingParticipant(
        {
          id: addItemState?.participant_id,
          pending_ticket_stub_ids: allPendingStubs,
        },
        true,
      );
      if (res?.status !== StatusCode.OK) {
        dispatch(showError(errorMessage(res, t("Error setting ticket stubs pending state"))));
      } else {
        dispatch(dequeue());
        void closeRedeemTicketModal();
        handleCloseSearchTicket();
        updateState<ICheckInState>({ ticketRedeemSuccess: true }, StateType.CheckInState);
        void dispatch(selectTeeTime(parseInt(teetimeId), true));
        return;
      }
    }

    dispatch(dequeue());
    void closeRedeemTicketModal();
    handleCloseSearchTicket();
    updateState<ICheckInState>(
      {
        ticketRedeemSuccess: true,
      },
      StateType.CheckInState,
    );

    // Reload the tee times
    void dispatch(selectTeeTime(parseInt(teetimeId), true));
  };

  async function handleRedeemMultipleTickets() {
    const bookingSlots = [...(teeSheetStore?.selectedTeeTime?.slots ?? [])];

    //Filter out participants whose green fees are already paid (booking-fee-only still eligible)
    const filteredSlots = bookingSlots?.filter(slot =>
      isSlotEligibleForTicketFeeRedemption(slot, state.selectedBooking?.id),
    );

    const participants = filteredSlots?.map(slot => slot?.booking_participant);

    let stubIds: number[] = [];

    stubIds = checkInState?.selectedCustomerTickets?.map(ticket => {
      return Number(ticket.id);
    });

    const ticketStubRes = await GetTicketStubRedemption(
      {
        ids: stubIds,
        extended: true,
      },
      true,
    );

    const ticketStubs = ticketStubRes.data;

    if (ticketStubRes.status !== StatusCode.OK) {
      dispatch(showError("Error redeeming ticket stub"));
      {
        /* TODO: Translate */
      }
      return;
    }

    setRedeemTicketState(prevState => ({
      ...prevState,
      redeemingMultipleTickets: true,
      multipleTicketParticipants: participants,
      ticketsToRedeem: ticketStubs,
      selectedTickets: ticketStubs,
      // currentTicket: ticketStubs[0],
      greenFeeQuantity: 0,
      powerCartQuantity: 0,
      totalTicketPages: ticketStubs.length,
      currentTicketPage: 1,
      assigningMultiUseTicket: false,
    }));
  }

  function handleRedeemMultiUseTicketAssignment(stub: IStub, quantity: number) {
    const bookingSlots = [...(teeSheetStore?.selectedTeeTime?.slots ?? [])];
    const filteredSlots = bookingSlots?.filter(slot =>
      isSlotEligibleForTicketFeeRedemption(slot, state.selectedBooking?.id),
    );
    const participants = filteredSlots?.map(slot => slot?.booking_participant) ?? [];
    const assignmentQuantity = Math.min(Math.max(1, quantity), getMaxRedemptionQuantity(stub));
    const assignmentTickets = Array.from({ length: assignmentQuantity }, (_, index) => ({
      ...stub,
      assignmentIndex: index,
    }));
    const { greenFeeQuantity, powerCartQuantity } = getAssignmentRedemptionQuantities(stub, true);

    setRedeemTicketState(prevState => ({
      ...prevState,
      redeemingMultipleTickets: true,
      assigningMultiUseTicket: true,
      multipleTicketParticipants: participants,
      ticketsToRedeem: assignmentTickets,
      selectedTickets: assignmentTickets,
      currentTicket: assignmentTickets[0],
      greenFeeQuantity,
      powerCartQuantity,
      powerCartMultipleTicketParticipantIds: [],
      greenFeeMultipleTicketParticipantIds: [],
      totalTicketPages: assignmentQuantity,
      currentTicketPage: 1,
      savedTicketPages: [],
    }));
  }

  async function redeemMultipleTickets() {
    //After a ticket redemption product is used on a participant, add the ticket code to this array to 'redeem' it
    const ticketCodesToRedeem: Array<number> = [];

    const completedTicketPages = [...(redeemTicketState?.savedTicketPages ?? [])];

    const redeemTicketPageInfo = {
      pageNumber: redeemTicketState?.currentTicketPage,
      ticket: redeemTicketState?.currentTicket,
      selectedGreenFeeParticipants: redeemTicketState?.greenFeeMultipleTicketParticipantIds,
      selectedPowerCartParticipants: redeemTicketState?.powerCartMultipleTicketParticipantIds,
    };

    completedTicketPages.push(redeemTicketPageInfo);

    type ParticipantRedemption = {
      participantId: number;
      greenFeeProductId: number | null;
      powerCartProductId: number | null;
    };

    const participantMap: Record<number, ParticipantRedemption> = {};

    completedTicketPages.forEach(({ ticket, selectedGreenFeeParticipants, selectedPowerCartParticipants }) => {
      ticketCodesToRedeem.push(Number(ticket.id));

      selectedGreenFeeParticipants.forEach(id => {
        if (!participantMap[id]) {
          participantMap[id] = { participantId: id, greenFeeProductId: null, powerCartProductId: null };
        }

        participantMap[id].greenFeeProductId = getAssignmentGreenFeeVariantId(ticket as IStub);
      });

      selectedPowerCartParticipants.forEach(id => {
        if (!participantMap[id]) {
          participantMap[id] = { participantId: id, greenFeeProductId: null, powerCartProductId: null };
        }
        participantMap[id].powerCartProductId = getAssignmentPowerCartVariantId(ticket as IStub);
      });
    });

    // Export as array
    const participantArray = Object.values(participantMap);

    dispatch(enqueue());
    try {
      let cart = null;
      if (!checkInState?.cart) {
        const postCartRes = await PostCart({ customer_id: null }, false);

        cart = postCartRes?.data;
        // Save cart to state
        updateState<ICheckInState>({ cart: postCartRes?.data, order: undefined }, StateType.CheckInState);
      }

      for (const array of participantArray) {
        const putBookingParticipantRes = await PutBookingParticipant(
          {
            id: array.participantId,
            green_fee_variant_id: array.greenFeeProductId,
            power_cart_variant_id: array.powerCartProductId,
          },
          false,
        );
        if (putBookingParticipantRes.status !== StatusCode.OK) {
          dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.182")));
          return;
        }

        const currentSlot = teeSheetStore.selectedTeeTime.slots.find(
          slot => slot.booking_participant.id === array.participantId,
        );
        if (!currentSlot) {
          continue;
        }

        //Use the participant returned from the update so the redemption product's price is sent to the cart
        const updatedParticipant = putBookingParticipantRes.data;
        const currentParticipant: ISlot = {
          ...currentSlot,
          booking_participant: updatedParticipant,
        };

        const greenFeeRedemptionProduct =
          updatedParticipant.green_fee_variant_id != null
            ? {
                id: updatedParticipant.green_fee_variant_id,
                variantTitle: updatedParticipant.green_fee_variant_title,
                productTitle: updatedParticipant.green_fee_product_title,
              }
            : null;

        const powerCartRedemptionProduct =
          updatedParticipant.power_cart_variant_id != null
            ? {
                id: updatedParticipant.power_cart_variant_id,
                variantTitle: updatedParticipant.power_cart_variant_title ?? "",
                productTitle: updatedParticipant.power_cart_product_title ?? "",
              }
            : null;

        await handleAddFee(currentParticipant, greenFeeRedemptionProduct, powerCartRedemptionProduct, null, cart as ICart);
      }

      if (ticketCodesToRedeem?.length > 0) {
        const allPendingStubs =
          checkInState?.ticketPendingStubIds && checkInState?.ticketPendingStubIds?.length > 0
            ? [...checkInState.ticketPendingStubIds, ...ticketCodesToRedeem]
            : ticketCodesToRedeem;
        const res = await PutBookingParticipant(
          {
            id: addItemState?.participant_id,
            pending_ticket_stub_ids: allPendingStubs,
          },
          false,
        );

        if (res?.status !== StatusCode.OK) {
          dispatch(showError(errorMessage(res, t("Error setting ticket stubs pending state"))));
        }
      }

      dispatch(
        showSuccess(
          `${
            checkInState.selectedCustomerTickets.length > 1
              ? t("secure.facility.tee_sheet.tee_sheet_booking_details.213")
              : t("secure.facility.tee_sheet.tee_sheet_booking_details.214")
          }
        ${t("secure.facility.tee_sheet.tee_sheet_booking_details.215")}`,
        ),
      );

      void closeRedeemTicketModal();

      handleCloseSearchTicket();

      updateState<ICheckInState>(
        {
          ticketRedeemSuccess: true,
          redeem_ticket_code: "",
          redeemTicketSelected: 0,
          selectedTickets: [],
          selectedCustomerTickets: [],
          redeemTicketActive: false,
        },
        StateType.CheckInState,
      );

      setRedeemTicketState(prevState => ({
        ...prevState,
        greenFeeQuantity: 0,
        powerCartQuantity: 0,
        redeemingMultipleTickets: false,
        assigningMultiUseTicket: false,
        greenFeeMultipleTicketParticipantIds: [],
        powerCartMultipleTicketParticipantIds: [],
        currentTicket: null,
        savedTicketPages: [],
        totalTicketPages: 0,
        multipleTicketParticipants: [],
        ticketsToRedeem: [],
        selectedTickets: [],
      }));

      // Reload the tee times
      void dispatch(selectTeeTime(parseInt(teetimeId), true));
    } finally {
      dispatch(dequeue());
    }
  }

  function closeRedeemTicketModal() {
    ReactDOM.unstable_batchedUpdates(() => {
      updateState<ICheckInState>(
        {
          ticketValidSuccess: false,
          redeem_ticket_code: "",
          getTicketValidateData: {},
          ticketRedeemSuccess: false,
        },
        StateType.CheckInState,
      );

      updateState<IAddItemState>(
        {
          participant_id: null,
        },
        StateType.AddItemState,
      );

      updateState<ICheckInState>(
        {
          ticketRedeemSuccess: true,
        },
        StateType.CheckInState,
      );
    });
  }

  const handleTicketValidSuccess = async () => {
    const selectedBookingParticipantIndex = teeSheetStore?.selectedTeeTime?.slots?.findIndex(
      slot => slot?.booking_participant?.id == addItemState?.participant_id,
    );
    if (selectedBookingParticipantIndex === -1) {
      console.log("Cannot find selected booking participant slot");
      {
        /* TODO: Translate */
      }
      {
        /* TODO: Translate */
      }
      return;
    }

    const bookingSlots = [...teeSheetStore.selectedTeeTime.slots];
    //Order the slots so that the next participant after the current one has the ticket applied, then continue from the first participant in the booking
    const slotsOrderUpdate = [
      ...bookingSlots.slice(selectedBookingParticipantIndex, bookingSlots?.length),
      ...bookingSlots.slice(0, selectedBookingParticipantIndex),
    ];
    //Filter out participants whose green fees are already paid (booking-fee-only still eligible)
    const filteredSlots = slotsOrderUpdate?.filter(slot =>
      isSlotEligibleForTicketFeeRedemption(slot, state.selectedBooking?.id),
    );

    //Set the participant ids in an array
    const participantIds = filteredSlots?.map(slot => slot?.booking_participant?.id);

    const greenFeeProduct = checkInState.getTicketValidateData.redemption_products?.green_fee || null;
    const powerCartProduct = checkInState.getTicketValidateData.redemption_products?.power_cart || null;

    const greenFeeQuantity = greenFeeProduct?.pivot?.quantity;
    const powerCartQuantity = powerCartProduct?.pivot?.quantity;

    if (
      ((greenFeeProduct && greenFeeQuantity >= 1) || (powerCartProduct && powerCartQuantity >= 1)) &&
      participantIds?.length > 0
    ) {
      //Get the max quantity between the green fee & power cart
      const higherQuantity =
        greenFeeQuantity && powerCartQuantity
          ? Math.max(greenFeeQuantity, powerCartQuantity)
          : greenFeeQuantity
          ? greenFeeQuantity
          : powerCartQuantity;
      let currentGreenFeeAmount = greenFeeQuantity;
      let currentPowerCartAmount = powerCartQuantity;
      for (const i of [...Array(higherQuantity).keys()]) {
        const putBookingParticipantRes = await PutBookingParticipant(
          {
            id: participantIds[0],
            green_fee_variant_id:
              greenFeeProduct && currentGreenFeeAmount >= 1 ? greenFeeProduct?.pivot?.variant_id : undefined,
            power_cart_variant_id:
              powerCartProduct && currentPowerCartAmount >= 1 ? powerCartProduct?.pivot?.variant_id : undefined,
          },
          true,
        );
        if (putBookingParticipantRes.status !== StatusCode.OK) {
          dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.182")));
          return;
        }
        //Remove the first booking participant in the array to move onto the next participant
        participantIds.shift();
        //Decrement the green fee / power cart quantity
        currentGreenFeeAmount -= 1;
        currentPowerCartAmount -= 1;
        //If the max quantity between the green fee / power cart is reached or there are no participants left to apply the ticket,
        //break out of the loop and redeem the ticket and close the modal
        if (i === higherQuantity - 1 || participantIds?.length === 0) {
          break;
        }
      }
    }

    //Redeem ticket even if there is no green fee / power cart returned on the ticket
    //Some facilities like to redeem the ticket then manually apply the prepaid items
    const putRedeemRes = await PutRedeem({ code: checkInState.getTicketValidateData.stub.code }, true);
    if (putRedeemRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.162")));
    } else {
      dispatch(showSuccess(t("secure.facility.tee_sheet.tee_sheet_booking_details.161")));
    }

    void closeRedeemTicketModal();

    handleCloseSearchTicket();

    // Reload the tee times
    void dispatch(selectTeeTime(parseInt(teetimeId), true));
  };

  const handleTicketValidWarning = () => {
    // handle warning
    ReactDOM.unstable_batchedUpdates(() => {
      updateState<IMainState>({ selectedBooking: null }, StateType.MainState);
      updateState<ICheckInState>({ ticketValidWarning: false }, StateType.CheckInState);
    });
  };

  const handleCloseSearchTicket = () => {
    if (redeemTicketState?.redeemingMultipleTickets) {
      setRedeemTicketState(prevState => ({
        ...prevState,
        greenFeeQuantity: 0,
        powerCartQuantity: 0,
        redeemingMultipleTickets: false,
        assigningMultiUseTicket: false,
        greenFeeMultipleTicketParticipantIds: [],
        powerCartMultipleTicketParticipantIds: [],
        currentTicket: null,
        savedTicketPages: [],
        totalTicketPages: 0,
        multipleTicketParticipants: [],
        ticketsToRedeem: [],
        selectedTickets: [],
      }));
      return;
    }

    updateState<ICheckInState>(
      {
        redeemTicketActive: false,
        redeem_ticket_code: "",
        redeemTicketSelected: 0,
        selectedTickets: [],
        selectedCustomerTickets: [],
        selectedCustomerTicketQuantities: {},
        selectedTicketQuantities: {},
        ticketPendingStubIds: [],
        ticketParticipantId: null,
      },
      StateType.CheckInState,
    );

    setTicketState(prevState => ({ ...prevState, tickets: [], ticketString: "" }));
  };

  function handleChargeNoShowModalClose() {
    updateState<INoShowState>(
      {
        noShowActive: false,
        bookingParticipantIds: [],
        paymentMethodID: null,
        quantity: 0,
      },
      StateType.NoShowState,
    );
  }

  async function loadGreenFeeProducts() {
    const items = await GetProduct({ type: "No Show Green Fee", extended: true }, true);
    if (items.status !== StatusCode.OK) {
      dispatch(showError(items.message));
      return;
    }
    updateState<INoShowState>({ greenFeeProducts: items.data }, StateType.NoShowState);
  }

  function handleChangePlayerSelection(id: number, customer: ICustomer) {
    setChangePlayerState(prevState => ({ ...prevState, selectedCustomer: customer }));
  }

  function handleShowChangePlayer(bookingParticipant: IBookingParticipant) {
    setChangePlayerState(prevState => ({
      ...prevState,
      showChangePlayer: true,
      customerQuery: "",
      playerSearchResult: [],
      bookingParticipant,
    }));
  }

  function changePlayerHandleCustomerSearch(query: string) {
    setChangePlayerState(prevState => ({ ...prevState, customerQuery: query }));
  }

  async function changeSelectedPlayer() {
    const bookingParticipantRes = await PutBookingParticipant(
      { id: changePlayerState.bookingParticipant.id, customer_id: changePlayerState.selectedCustomer.id },
      true,
    );
    if (bookingParticipantRes.status !== StatusCode.OK) {
      dispatch(showError(bookingParticipantRes.message));
      return;
    }
    dispatch(showSuccess(t("secure.facility.tee_sheet.tee_sheet_booking_details.216")));
    setChangePlayerState(prevState => ({
      ...prevState,
      bookingParticipant: null,
      showChangePlayer: false,
      playerSearchResult: [],
      customerQuery: "",
      selectedCustomer: null,
    }));
    void dispatch(selectTeeTime(parseInt(teetimeId), true));
  }

  function closeChangePlayer() {
    closeCreateNewCustomer();
    setChangePlayerState(prevState => ({
      ...prevState,
      showNewPlayer: false,
      bookingParticipant: null,
      showChangePlayer: false,
      customerQuery: "",
      playerSearchResult: [],
      selectedCustomer: null,
    }));
  }

  function closeCreateNewCustomer() {
    setChangePlayerState(prevState => ({
      ...prevState,
      showNewPlayer: false,
      first_name: "",
      last_name: "",
      phone: "",
      email: "",
    }));
  }

  async function createNewCustomer(customerInfo: ICustomerInfoState) {
    const inputError =
      customerInfo.firstName === "" ||
      customerInfo.lastName === "" ||
      (customerInfo.emailAddress === "" && customerInfo.phoneNumber === "");

    if (inputError) {
      dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.011")));
    }

    const customerRes = await PostCustomer(
      {
        first_name: customerInfo.firstName,
        last_name: customerInfo.lastName,
        phone: customerInfo.phoneNumber || null,
        email: customerInfo.emailAddress || null,
        state: "disabled",
      },
      true,
    );

    if (customerRes.status !== StatusCode.OK) {
      dispatch(showError(customerErrorMessage(t, customerRes?.data?.message as string)));
      return;
    }
    setChangePlayerState(prevState => ({
      ...prevState,
      showNewPlayer: false,
      selectedCustomer: customerRes.data,
      first_name: "",
      last_name: "",
      phone: "",
      email: "",
    }));

    // dispatch(showSuccess(customerRes.data.message));
    dispatch(showSuccess(t("Successfully created customer")));
  }

  async function changePlayerSearch(mounted: boolean, golferSearchQuery: string) {
    try {
      if (golferSearchQuery === "") {
        if (mounted) {
          setChangePlayerState(prevState => ({ ...prevState, playerSearchResult: [] }));
        }
        return;
      } else {
        setChangePlayerState(prevState => ({ ...prevState, customerSearching: true }));
        const customerRes = await GetCustomer({ search: golferSearchQuery }, false);
        if (customerRes.status !== StatusCode.OK) {
          setChangePlayerState(prevState => ({ ...prevState, customerSearching: false, playerSearchResult: [] }));
          return;
        } else if (mounted) {
          setChangePlayerState(prevState => ({
            ...prevState,
            customerSearching: false,
            playerSearchResult: customerRes.data,
          }));
        }
      }
    } catch (error) {
      console.log("err", error);
    }
    return;
  }

  const getDateTime = () => {
    const date = teeSheetStore.selectedTeeTime.date.split("-").join("/");
    const dateTime = new Date(date + ", " + teeSheetStore.selectedTeeTime.start_time);
    //Get the time 30 minutes before the current start time
    dateTime.setMinutes(dateTime.getMinutes() - 30);
    let hours = dateTime.getHours().toString();
    if (hours.length === 1) {
      hours = "0" + hours;
    }
    const adjustedTime = hours + ":" + dateTime.getMinutes().toString();
    return [date, adjustedTime];
  };

  const loadGroupPayTeeTimes = async (cancelToken: CancelToken) => {
    if (teeSheetStore.selectedTeeTime) {
      const selectedTeeTime = teeSheetStore.selectedTeeTime;
      const isShotgun = !!selectedTeeTime.shotgun_application_id;
      const dateTime = getDateTime();
      const teeTimesRes = await GetTeeTime(
        { date: dateTime[0], start_time: dateTime[1], extended: true },
        false,
        cancelToken,
      );
      if (teeTimesRes.status !== StatusCode.OK) {
        if (cancelToken && cancelToken.reason) {
          return;
        }
        dispatch(showError(teeTimesRes.message));
        return;
      }
      const teeTimes = teeTimesRes.data;
      const groupPayTeeTimes = teeTimes
        .filter(filteredTeeTime => {
          if (filteredTeeTime?.blocked_type === "crossover") {
            return false;
          }

          const validTeeTime = filteredTeeTime.slots.some(
            slot => slot.status === "booked" && slot.booking_participant.check_in_status === "unchecked",
          );
          if (!validTeeTime) {
            return false;
          }

          if (isShotgun) {
            return (
              filteredTeeTime.shotgun_application_id === selectedTeeTime.shotgun_application_id &&
              filteredTeeTime.id !== selectedTeeTime.id
            );
          }

          return filteredTeeTime.start_time !== selectedTeeTime.start_time;
        })
        .sort((a, b) => (isShotgun ? a.position - b.position : 0));
      updateState<IGroupPayState>({ groupPayTeeTimes }, StateType.GroupPayState);
    }
  };

  async function refreshTeeTime(refreshParticipantFees?: boolean, globalLoader?: boolean) {
    const teetimeRes = await GetTeeTime(
      {
        id: Number(teetimeId),
        locks: true,
        extended: true,
        "extended-bookings": true,
        turn_tee_time: true,
      },
      !!globalLoader,
    );

    if (teetimeRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.183")));
      updateState<IOrderComplete>({ loading: false }, StateType.OrderComplete);
      return;
    }

    const updatedTeeTime = teetimeRes.data[0];
    dispatch(selectTeeTimeSuccess(updatedTeeTime));

    //Get deposits if a booking made a deposit
    if (updatedTeeTime?.slots?.some(slot => slot?.booking?.deposit_id)) {
      void getDeposits(updatedTeeTime);
    }

    //Reset the participant paid fees values
    if (refreshParticipantFees) {
      void resetParticipantFees(teetimeRes?.data[0]);
      updateState<IOrderComplete>(
        {
          loading: false,
        },
        StateType.OrderComplete,
      );
    }
  }

  async function getDeposits(teetime: ITeeTime) {
    const depositIds: Array<number> = [];
    teetime?.slots?.forEach(slot => {
      if (slot?.booking?.deposit_id && !depositIds?.includes(Number(slot?.booking?.deposit_id))) {
        depositIds.push(Number(slot?.booking?.deposit_id));
      }
    });
    const depositRes = await Promise.all(depositIds?.map(depositId => GetBookingDeposit({ id: depositId }, false)));
    if (depositRes?.some(depositRes => depositRes?.status !== StatusCode.OK)) {
      dispatch(showError(t("Error getting booking deposits")));
      return;
    }

    const deposits = depositRes?.filter(res => res?.status == StatusCode.OK)?.map(res => res?.data);
    const uniqueDeposits = [].concat(...new Set(deposits));
    setDeposits(uniqueDeposits);
  }

  const handleBackToCheckIn = () => {
    ReactDOM.unstable_batchedUpdates(() => {
      updateState<IOrderProgess>({ orderStep: OrderProgress.NEW_ORDER }, StateType.OrderProgress);
      updateState<ICheckInState>(
        {
          order: null,
          cart: null,
        },
        StateType.CheckInState,
      );
      updateState<IOrderComplete>(
        {
          isOpen: false,
          clearOnClose: true,
          loading: false,
          transactionComplete: false,
        },
        StateType.OrderComplete,
      );
    });
  };

  async function loadCartWaiver(customer_id: number) {
    const waiverRes = await GetCartWaiver(
      { customer_id: customer_id, tee_time_id: teeSheetStore.selectedTeeTime.id },
      true,
    );

    if (waiverRes.status === StatusCode.OK) {
      window.open().document.write(waiverRes.data as string);
    } else {
      dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.217")));
    }
  }

  async function handleCartWaiverPrinted(bookingId: number) {
    const resolvedBookingId = Number(bookingId);
    if (!Number.isFinite(resolvedBookingId)) {
      return;
    }

    const bookingKey = String(resolvedBookingId);
    const slotPrinted =
      slots.find(slot => Number(slot.booking?.id ?? slot.tee_time_booking_id) === resolvedBookingId)?.booking
        ?.waivers_printed ?? 0;
    const knownPrinted = cartWaiverPrintedCountsRef.current[bookingKey] ?? 0;
    const nextWaiversPrinted = Math.max(slotPrinted, knownPrinted) + 1;
    cartWaiverPrintedCountsRef.current[bookingKey] = nextWaiversPrinted;

    if (cartWaiverSnapshotRef.current?.bookingId !== resolvedBookingId) {
      const quantity =
        slots.find(slot => Number(slot.booking?.id ?? slot.tee_time_booking_id) === resolvedBookingId)?.booking
          ?.quantity ?? 0;
      cartWaiverSnapshotRef.current = {
        bookingId: resolvedBookingId,
        limit: Math.max(Math.ceil(quantity / 2), 1),
      };
    }

    const selectedTeeTime = teeSheetStore.selectedTeeTime;
    if (selectedTeeTime?.slots) {
      const updatedTeeTime = {
        ...selectedTeeTime,
        slots: selectedTeeTime.slots.map(slot => {
          const slotBookingId = Number(slot.booking?.id ?? slot.tee_time_booking_id);
          if (slotBookingId !== resolvedBookingId || !slot.booking) {
            return slot;
          }
          return {
            ...slot,
            booking: {
              ...slot.booking,
              waivers_printed: nextWaiversPrinted,
            },
          };
        }),
      };
      dispatch(selectTeeTimeSuccess(updatedTeeTime));
    }

    const putRes = await PutBookingWaiversPrinted(
      { id: resolvedBookingId, waivers_printed: nextWaiversPrinted },
      false,
    );
    if (putRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error updating cart waiver print count")));
    } else if (typeof putRes.data?.waivers_printed === "number") {
      cartWaiverPrintedCountsRef.current[bookingKey] = Math.max(
        cartWaiverPrintedCountsRef.current[bookingKey] ?? 0,
        putRes.data.waivers_printed,
      );
    }
  }

  async function loadLiabilityWaiver(customer_id: number, waiver_id: number) {
    const waiverRes = await PrintLiabilityWaiver(
      {
        id: waiver_id,
        tee_time_id: teeSheetStore.selectedTeeTime.id,
        customer_id: customer_id,
      },
      true,
    );

    if (waiverRes.status === StatusCode.OK) {
      window.open().document.write(waiverRes.data as string);
    } else {
      dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.217")));
    }
  }

  function onCancelAddGreenFeeModal() {
    updateState<IAddItemState>({ greenFeeActive: false }, StateType.AddItemState);
    void cancelAddItem();
  }

  function onCancelAddPowerCartModal() {
    updateState<IAddItemState>({ powerCartFeeActive: false }, StateType.AddItemState);
    void cancelAddItem();
  }

  function onClickProduct(product: IProduct, product_type: "Green Fee" | "Power Cart") {
    const variants = product?.variants?.filter(variant => variant?.facility_access === true);

    if (variants?.length > 1) {
      updateState<IAddItemState>(
        {
          productState: {
            ...addItemState.productState,
            variantSheetOpen: true,
            variants,
            selectedProduct: product,
          },
        },
        StateType.AddItemState,
      );
    } else {
      if (variants?.[0]) {
        void handleAddQuickItem(variants[0], product_type, product);
      } else {
        dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.187")));
      }
    }
  }

  function onCancelAddVariantModal() {
    updateState<IAddItemState>(
      {
        productState: {
          variantSheetOpen: false,
          variants: [],
          selectedProduct: undefined,
        },
      },
      StateType.AddItemState,
    );
  }

  async function addAllGroupPay(slots: Array<ISlot>) {
    const filteredSlots = slots?.filter(slot => slot?.booking_participant?.check_in_status === "unchecked");
    const newParticipants: TParticipantPaidFees = [];

    //Return to cart page if a product is added when the payment methods page is displayed
    if (registerState?.page === null) {
      updateRegisterState({ page: "cart" });
    }

    //Add participants to fees list if the participants are not already in the list
    filteredSlots?.forEach(slot => {
      const foundParticipant = participantPaidFees?.current?.find(
        participant => participant?.booking_participant_id === slot?.booking_participant?.id,
      );
      if (!foundParticipant) {
        newParticipants.push({
          booking_participant_id: slot?.booking_participant?.id,
          green_fee: slot?.booking_participant?.green_fee_paid,
          power_cart_fee: slot?.booking_participant?.power_cart_paid,
          green_fee_loading: false,
          power_cart_fee_loading: false,
        });
      }
    });
    //Initialize participant fees
    if (newParticipants?.length > 0) {
      const currentFees = [...participantPaidFees.current, ...newParticipants];
      void initializeParticipantPaidFees(currentFees);
    }

    const { greenFeeCounts, powerCartCounts, feeList } = determineFeeCounts(filteredSlots);
    const variants = [...greenFeeCounts, ...powerCartCounts];

    if (variants?.length > 0 && checkInState?.cart) {
      //Set participant fees spinners
      participantPaidFees?.current?.forEach(participant => {
        const foundParticipant = filteredSlots?.find(
          slot => slot?.booking_participant?.id === participant?.booking_participant_id,
        );
        if (foundParticipant) {
          void updateParticipantPaidFees({
            ...participant,
            green_fee_loading: participant?.green_fee
              ? false
              : !!foundParticipant?.booking_participant?.green_fee_variant_id,
            power_cart_fee_loading: participant?.power_cart_fee
              ? false
              : !!foundParticipant?.booking_participant?.power_cart_variant_id,
          });
        }
      });

      updateState<IOrderProgess>({ orderStep: OrderProgress.ADDING_FEES }, StateType.OrderProgress);
      //Display loading variants in cart
      variants?.forEach(variant => {
        void addLoadingVariant(
          { id: Number(variant?.variantId), title: variant?.title, quantity: variant?.quantity } as IVariant,
          { title: variant?.productTitle } as IProduct,
        );
      });
      //Set variants param
      const variantsParam = variants?.map(item => ({ variant_id: item?.variantId, quantity: item?.quantity }));

      const postLineItemRes = await PostLineItemToCart(
        {
          cart_id: checkInState.cart.id,
          variants: variantsParam,
        },
        false,
      );
      //Remove loading variants in cart
      variants?.forEach(variant => {
        void removeLoadingVariant(Number(variant?.variantId));
      });

      if (postLineItemRes.status !== StatusCode.OK) {
        dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.218")));
        participantPaidFees?.current?.forEach(participant => {
          void updateParticipantPaidFees({
            ...participant,
            green_fee_loading: false,
            power_cart_fee_loading: false,
            green_fee: participant?.green_fee,
            power_cart_fee: participant?.power_cart_fee,
          });
        });
        updateState<IOrderProgess>({ orderStep: OrderProgress.ORDER_IN_PROGRESS }, StateType.OrderProgress);
        return;
      }

      //Set participant fees
      participantPaidFees?.current?.forEach(participant => {
        const currentParticipant = feeList?.find(
          participantFees => Number(participantFees?.participant_id) === participant?.booking_participant_id,
        );
        if (currentParticipant) {
          void updateParticipantPaidFees({
            ...participant,
            green_fee_loading: false,
            power_cart_fee_loading: false,
            green_fee:
              currentParticipant?.greenFeeChecked !== undefined
                ? currentParticipant?.greenFeeChecked
                : participant?.green_fee,
            power_cart_fee:
              currentParticipant?.powerCartChecked !== undefined
                ? currentParticipant?.powerCartChecked
                : participant?.power_cart_fee,
          });
        }
      });

      //Save cart to state
      ReactDOM.unstable_batchedUpdates(() => {
        updateState<ICheckInState>({ cart: postLineItemRes?.data }, StateType.CheckInState);
        updateState<IOrderProgess>({ orderStep: OrderProgress.ORDER_IN_PROGRESS }, StateType.OrderProgress);
      });
    }
  }

  // Map through slots to return green fees and power cart fees
  function determineFeeCounts(slots: ISlot[]) {
    const greenFeeVariants: Array<{
      variantId: number;
      title: string;
      productTitle: string;
      quantity: number;
      tee_time_booking_id: number;
    }> = [];
    const powerCartVariants: Array<{ variantId: number; title: string; productTitle: string; quantity: number }> = [];
    const participantFeeStatus: FeeStatusType = {};

    slots.map(slot => {
      if (!slot.booking_participant) {
        return;
      }

      const greenFeeAdded = participantPaidFees?.current?.some(item => {
        if (item?.booking_participant_id === slot?.booking_participant?.id) {
          return item.green_fee === true || item?.green_fee_loading;
        }
      });
      const powerCartFeeAdded = participantPaidFees?.current?.some(item => {
        if (item?.booking_participant_id === slot?.booking_participant?.id) {
          return item.power_cart_fee === true || item?.power_cart_fee_loading;
        }
      });

      // Not paid, not previously added green fee
      if (
        !slot.booking_participant.green_fee_paid &&
        !greenFeeAdded &&
        slot.booking_participant.green_fee_product_title
      ) {
        greenFeeVariants.push({
          variantId: slot.booking_participant?.green_fee_variant_id,
          title: slot.booking_participant?.green_fee_variant_title,
          productTitle: slot.booking_participant?.green_fee_product_title,
          quantity: 1,
          tee_time_booking_id: slot.tee_time_booking_id,
        });
        //Set participant fee status
        participantFeeStatus[slot.booking_participant.id] = {
          ...participantFeeStatus[slot.booking_participant.id],
          greenFeeChecked: true,
        };
      }

      // Not paid, not previously added power cart fee
      if (
        !slot.booking_participant.power_cart_paid &&
        !powerCartFeeAdded &&
        slot.booking_participant.power_cart_product_title
      ) {
        powerCartVariants.push({
          variantId: slot.booking_participant?.power_cart_variant_id,
          title: slot.booking_participant?.power_cart_variant_title,
          productTitle: slot.booking_participant?.power_cart_product_title,
          quantity: 1,
        });

        participantFeeStatus[slot.booking_participant.id] = {
          ...participantFeeStatus[slot.booking_participant.id],
          powerCartChecked: true,
        };
      }
    });

    const feeStatusObj = Object.entries(participantFeeStatus).map(key => {
      return {
        participant_id: key[0],
        greenFeeChecked: key[1].greenFeeChecked,
        powerCartChecked: key[1].powerCartChecked,
      };
    });

    return {
      greenFeeCounts: greenFeeVariants,
      powerCartCounts: powerCartVariants,
      feeList: feeStatusObj,
    };
  }

  async function createCart() {
    if (!checkInState.cart?.id || orderProgress.orderStep === OrderProgress.NEW_ORDER) {
      if (orderProgress.orderStep !== OrderProgress.CREATING_CART) {
        updateState<IOrderProgess>({ orderStep: OrderProgress.CREATING_CART }, StateType.OrderProgress);
      }
      const postCartRes = await PostCart(null, false);
      if (postCartRes.status === StatusCode.OK) {
        ReactDOM.unstable_batchedUpdates(() => {
          updateState<ICheckInState>({ cart: postCartRes.data, order: undefined }, StateType.CheckInState);
          updateState<IOrderProgess>(
            {
              orderStep: OrderProgress.ORDER_IN_PROGRESS,
            },
            StateType.OrderProgress,
          );
        });
      } else {
        dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.189")));
        updateState<IOrderProgess>({ orderStep: OrderProgress.NEW_ORDER }, StateType.OrderProgress);
      }
    }
  }

  function togglePowerCartVisible(visible: boolean) {
    updateState<IMainState>({ powerCartModalVisible: visible }, StateType.MainState);
  }

  const tabs = [
    {
      id: "redeem-ticket-scan",
      content: t("secure.facility.tee_sheet.tee_sheet_booking_details.040"),
    },
    {
      id: "redeem-ticker-available",
      content: t("secure.facility.tee_sheet.tee_sheet_booking_details.041"),
    },
  ];

  const handleSearchTicketTabChange = (value: number) => {
    updateState<ICheckInState>({ redeemTicketSelected: value }, StateType.CheckInState);
  };

  function handleTeeTimeCancelledPopupRefresh() {
    void dispatch(selectTeeTime(teeSheetStore.selectedTeeTime.id, false));
    updateState<IMainState>({ teeTimeCancelledPopupVisible: false }, StateType.MainState);
  }

  function filterGreenFees(event: any) {
    const keyword = String(event.target.value);
    const trimmedKeyword = keyword.trim();

    if (trimmedKeyword !== "") {
      const results = addItemState.itemSearchResult.filter(item => {
        const search = trimmedKeyword.toLowerCase();
        const title = (item?.title ?? "").toLowerCase();
        const type = String(item?.type ?? "").toLowerCase();

        return title.includes(search) || type.includes(search);
      });

      setFoundGreenFees(results);
    } else {
      setFoundGreenFees([]);
    }

    updateState<IAddItemState>({ greenfeeSearchQuery: keyword }, StateType.AddItemState);
  }

  function filterCartItems(event: any) {
    const keyword = String(event.target.value);
    const trimmedKeyword = keyword.trim();

    if (trimmedKeyword !== "") {
      const results = addItemState.itemSearchResult.filter(item => {
        const search = trimmedKeyword.toLowerCase();
        const title = (item?.title ?? "").toLowerCase();
        const type = String(item?.type ?? "").toLowerCase();

        return title.includes(search) || type.includes(search);
      });

      setFoundCartItems(results);
    } else {
      setFoundCartItems([]);
    }

    updateState<IAddItemState>({ cartSearchQuery: keyword }, StateType.AddItemState);
  }

  function alphaSortProducts(products: IProduct[]) {
    const productsCopy: IProduct[] = [...products];

    productsCopy.sort((firstProd: IProduct, secondProd: IProduct) => {
      if (firstProd?.title < secondProd?.title) {
        return -1;
      } else if (firstProd?.title > secondProd?.title) {
        return 1;
      } else {
        return 0;
      }
    });

    return productsCopy;
  }

  async function handleAddAllFees(slots: ISlot[], type: "green_fees" | "power_carts") {
    //Return to cart page if a product is added when the payment methods page is displayed
    if (registerState?.page === null) {
      updateRegisterState({ page: "cart" });
    }
    const { greenFeeCounts, powerCartCounts, feeList } = determineFeeCounts(slots);
    const customerId = !slots[0].booking_participant?.guest ? slots[0]?.booking_participant?.customer_id : null;
    let cart = checkInState?.cart ? checkInState?.cart : null;

    if (
      orderProgress?.orderStep === OrderProgress.CREATING_CART ||
      orderProgress?.orderStep === OrderProgress.ADDING_FEES ||
      (greenFeeCounts.length === 0 && powerCartCounts.length === 0)
    ) {
      return;
    }
    //Set participant fees loaders
    participantPaidFees?.current?.forEach(participant => {
      const currentParticipant = feeList?.find(
        participantFees => Number(participantFees?.participant_id) === participant?.booking_participant_id,
      );
      if (currentParticipant) {
        void updateParticipantPaidFees({
          ...participant,
          green_fee_loading:
            type === "green_fees" ? currentParticipant?.greenFeeChecked : participant?.green_fee_loading,
          power_cart_fee_loading:
            type === "power_carts" ? currentParticipant?.powerCartChecked : participant?.power_cart_fee_loading,
        });
      }
    });

    if (!cart || orderProgress.orderStep === OrderProgress.NEW_ORDER) {
      //Cart doesn't exist, create a cart first
      updateState<IOrderProgess>({ orderStep: OrderProgress.CREATING_CART }, StateType.OrderProgress);
      const postCartRes = await PostCart({ customer_id: customerId }, false);

      if (postCartRes?.status !== StatusCode.OK) {
        dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.203")));
        participantPaidFees?.current?.forEach(participant => {
          const currentParticipant = feeList?.find(
            participantFees => Number(participantFees?.participant_id) === participant?.booking_participant_id,
          );
          if (currentParticipant) {
            void updateParticipantPaidFees({
              ...participant,
              green_fee_loading: false,
              power_cart_fee_loading: false,
              green_fee: false,
              power_cart_fee: false,
            });
          }
        });
        updateState<IOrderProgess>({ orderStep: OrderProgress.NEW_ORDER }, StateType.OrderProgress);
        return;
      }
      cart = postCartRes?.data;
      // Save cart to state
      updateState<ICheckInState>({ cart: postCartRes?.data, order: undefined }, StateType.CheckInState);
    }

    const variants: Array<{
      variantId: number;
      title: string;
      productTitle: string;
      quantity: number;
      tee_time_booking_id?: number;
    }> = type === "green_fees" ? [...greenFeeCounts] : [...powerCartCounts];
    if (variants?.length > 0 && cart) {
      //Display loading variants in cart
      variants?.forEach(variant => {
        void addLoadingVariant(
          { id: Number(variant?.variantId), title: variant?.title, quantity: variant?.quantity } as IVariant,
          { title: variant?.productTitle } as IProduct,
        );
      });
      updateState<IOrderProgess>({ orderStep: OrderProgress.ADDING_FEES }, StateType.OrderProgress);

      const variantsParam = variants?.map(item => ({
        variant_id: item?.variantId,
        quantity: item?.quantity,
        tee_time_booking_id: item.tee_time_booking_id,
      }));
      const lineItemRes = await PostLineItemToCart(
        {
          cart_id: cart?.id,
          variants: variantsParam,
          line_items_stack: false,
        },
        false,
      );
      //Remove loading variants in cart
      variants?.forEach(variant => {
        void removeLoadingVariant(Number(variant?.variantId));
      });

      if (lineItemRes?.status !== StatusCode.OK) {
        dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.219")));
        participantPaidFees?.current?.forEach(participant => {
          const currentParticipant = feeList?.find(
            participantFees => Number(participantFees?.participant_id) === participant?.booking_participant_id,
          );
          if (currentParticipant) {
            void updateParticipantPaidFees({
              ...participant,
              green_fee_loading: false,
              power_cart_fee_loading: false,
              green_fee: false,
              power_cart_fee: false,
            });
          }
        });
        updateState<IOrderProgess>({ orderStep: OrderProgress.NEW_ORDER }, StateType.OrderProgress);
        return;
      }

      //Set participant fees
      participantPaidFees?.current?.forEach(participant => {
        const currentParticipant = feeList?.find(
          participantFees => Number(participantFees?.participant_id) === participant?.booking_participant_id,
        );
        if (currentParticipant) {
          void updateParticipantPaidFees({
            ...participant,
            green_fee_loading: false,
            power_cart_fee_loading: false,
            green_fee:
              type === "green_fees" && currentParticipant?.greenFeeChecked !== undefined
                ? currentParticipant?.greenFeeChecked
                : participant?.green_fee,
            power_cart_fee:
              type === "power_carts" && currentParticipant?.powerCartChecked !== undefined
                ? currentParticipant?.powerCartChecked
                : participant?.power_cart_fee,
          });
        }
      });

      //Save cart to state
      ReactDOM.unstable_batchedUpdates(() => {
        updateState<ICheckInState>({ cart: lineItemRes?.data }, StateType.CheckInState);
        updateState<IOrderProgess>({ orderStep: OrderProgress.ORDER_IN_PROGRESS }, StateType.OrderProgress);
      });
    } else {
      if (cart) {
        updateState<IOrderProgess>({ orderStep: OrderProgress.ORDER_IN_PROGRESS }, StateType.OrderProgress);
      } else {
        updateState<IOrderProgess>({ orderStep: OrderProgress.NEW_ORDER }, StateType.OrderProgress);
      }
    }
  }

  async function handleCheckParticipants(order: IOrder) {
    const participantsToCheckIn = [...participantPaidFees.current]
      ?.filter(participant => participant?.green_fee || participant?.power_cart_fee)
      ?.map(participant => ({
        participant: participant,
        booking_participant_id: participant?.booking_participant_id,
        green_fee_paid: participant?.green_fee,
        power_cart_paid: participant?.power_cart_fee,
      }));

    if (order && participantsToCheckIn?.length > 0) {
      const checkInRes = await PutCheckParticipantAll(
        { booking_participants: participantsToCheckIn, order_id: order?.id },
        false,
      );
      if (checkInRes?.status !== StatusCode?.OK) {
        dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.220")));
        return;
      }
    }

    if (order) {
      const stubsToRedeem: Array<{ customerId: number; participantId: number; stubIds: Array<number> }> = [];
      teeSheetStore?.selectedTeeTime?.slots?.forEach(slot => {
        if (slot?.booking_participant?.pending_ticket_stub_ids?.length) {
          stubsToRedeem.push({
            customerId: slot.booking_participant.customer_id,
            stubIds: slot.booking_participant.pending_ticket_stub_ids,
            participantId: slot.booking_participant.id,
          });
        }
      });

      if (stubsToRedeem?.length > 0) {
        const res = await Promise.all(
          stubsToRedeem?.map(stub =>
            PutTicketStubRedeemMultiple(
              {
                ticket_stub_ids: stub?.stubIds,
                customer_id: stub?.customerId ?? undefined,
                booking_participant_id: stub?.participantId,
                order_id: order?.id,
              },
              false,
            ),
          ),
        );
        if (res?.some(response => response?.status !== StatusCode.OK)) {
          dispatch(showError(t("Error redeeming ticket stubs")));
          return;
        }
        setStubsToRedeem(
          stubsToRedeem?.reduce((stubsArray, currentStub) => {
            return [...stubsArray, ...currentStub.stubIds];
          }, [] as Array<number>),
        );
      }
    }

    void refreshTeeTime(true);
  }

  function resetParticipantFees(teeTime: ITeeTime) {
    const participants = { ...teeTime }?.slots
      ?.map(slot =>
        slot?.booking_participant
          ? {
              booking_participant_id: slot?.booking_participant?.id,
              green_fee: slot?.booking_participant?.green_fee_paid ? undefined : false,
              power_cart_fee: slot?.booking_participant?.power_cart_paid ? undefined : false,
              green_fee_loading: false,
              power_cart_fee_loading: false,
            }
          : null,
      )
      ?.filter?.(filteredSlot => filteredSlot != null);
    void initializeParticipantPaidFees(participants);
  }

  function handleEnterKeydown(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.code === "Enter" || e.code === "NumpadEnter") {
      void addTicket();
    }
  }

  function addTicket() {
    if (ticketState.ticketString) {
      const updatedTickets = [...ticketState.tickets];
      const productIncremented = incrementProductQuantity();
      if (!productIncremented) {
        const foundSkuIndex = updatedTickets?.findIndex(skuObj => skuObj.sku === ticketState.ticketString);
        if (foundSkuIndex !== -1) {
          //Increment quantity of sku found
          const foundSku = updatedTickets[foundSkuIndex];
          updatedTickets.splice(foundSkuIndex, 1, { ...foundSku, quantity: ++foundSku.quantity });
        } else {
          //Add new sku
          const newSku: TSku = { sku: ticketState.ticketString, quantity: 1, searched: false };
          updatedTickets.push(newSku);
        }
        setTicketState(prevState => ({ ...prevState, tickets: updatedTickets }));
      } else {
        setTicketState(prevState => ({ ...prevState, ticketString: "" }));
      }
    }
  }

  function incrementProductQuantity() {
    // const tickets = [...checkInState?.selectedTickets];
    const productInList = false;
    // const variantIndex: number = null;
    // const ticketIndex = tickets?.findIndex(ticket => {
    //   // const foundTicketIndex = product?.variants?.findIndex(
    //   //   variant => variant?.sku === currentSku || variant?.barcode === currentSku,
    //   // );
    //   // if (foundVariantIndex !== -1) {
    //   //   variantIndex = foundVariantIndex;
    //   //   return true;
    //   // }
    // });
    // if (productIndex !== -1 && variantIndex !== -1) {
    //   // Product already in list, increment the quantity
    //   const foundVariant = products[productIndex]?.variants[variantIndex];
    //   products[productIndex].variants[variantIndex] = { ...foundVariant, quantity: ++foundVariant.quantity };
    //   productInList = true;
    //   setProductState(prevState => ({ ...prevState, selectedProducts: products }));
    // }
    return productInList;
  }

  function handleEnterClick() {
    const skuSearchId = document.getElementById("ticketSearchId");
    skuSearchId.focus();
    void addTicket();
  }

  //For searching tickets by sku
  useEffect(() => {
    const source = axios.CancelToken.source();
    const currentTicket = ticketState?.ticketString?.slice();
    const skuIndex = ticketState?.tickets?.findIndex(sku => sku.sku === currentTicket);
    // setTicketState((prevState) => ({ ...prevState, ticketString: "" }));
    if (skuIndex !== -1) {
      const foundSku = ticketState.tickets[skuIndex];
      // First sku added, search to see if ticket exists
      if (foundSku.quantity === 1 || !foundSku?.searched) {
        setTicketState(prevState => ({ ...prevState, ticketString: "" }));
        void validateTicket(currentTicket);
      }
    }
    return () => {
      source.cancel();
    };
  }, [ticketState?.tickets]);

  async function validateTicket(code: string) {
    const source = axios.CancelToken.source();

    const updatedTickets = cloneDeep(ticketState.tickets);
    //Filter out skus that have already been searched
    const skus = updatedTickets?.filter(filteredSku => !filteredSku?.searched)?.map(sku => sku.sku);
    if (skus.length === 0) {
      console.log("Ticket already searched");
      {
        /* TODO: Translate */
      }
      return;
    }

    const getTicketValidateRes = await GetTicketValidate({ code }, false);

    if (getTicketValidateRes.status !== StatusCode.OK) {
      if (source.token?.reason) {
        return;
      }
      if (getTicketValidateRes.status === StatusCode.BAD_REQUEST) {
        dispatch(showError(t("secure.facility.tee_sheet.tee_sheet_booking_details.247")));
      }
    } else if (getTicketValidateRes.data) {
      const ticketStub = getTicketValidateRes?.data?.stub;

      const foundTicketIndex = updatedTickets?.findIndex(sku => sku.sku === ticketStub?.code);

      if (foundTicketIndex !== -1) {
        updatedTickets.splice(foundTicketIndex, 1);
      }

      const updatedSelectedTickets = [...checkInState.selectedTickets];
      const selectedTicketIndex = updatedSelectedTickets?.findIndex(
        currentTicket => currentTicket.id === ticketStub.id,
      );
      if (selectedTicketIndex !== -1) {
        // Ticket already in state
      } else {
        //Product not in state, add it to the array
        const updatedStub = {
          ...ticketStub,
          redemption_product: getTicketValidateRes?.data?.redemption_products as any,
        };
        updatedSelectedTickets.push(updatedStub);
      }

      setCheckInState(prevState => ({
        ...prevState,
        selectedTickets: updatedSelectedTickets,
        selectedTicketQuantities: isMultiUseTicket(ticketStub)
          ? { ...prevState.selectedTicketQuantities, [ticketStub.id]: prevState.selectedTicketQuantities[ticketStub.id] ?? 1 }
          : prevState.selectedTicketQuantities,
      }));
    }

    updatedTickets?.forEach((sku, index) => {
      updatedTickets[index] = { ...updatedTickets[index], searched: true };
    });

    setTicketState(prevState => ({ ...prevState, tickets: updatedTickets }));
  }

  function removeTicketSku(index: number) {
    const updatedSkus = [...ticketState.tickets];
    // Sku cannot be removed if search is in progress
    const allSkusSearched = updatedSkus?.every(sku => sku.searched);
    if (updatedSkus[index] && allSkusSearched) {
      updatedSkus.splice(index, 1);
      setTicketState(prevState => ({ ...prevState, tickets: updatedSkus }));
    }
  }

  function removeTicket(ticketIndex: number) {
    const updatedTickets = [...checkInState.selectedTickets];
    updatedTickets.splice(ticketIndex, 1);

    setCheckInState(prevState => ({
      ...prevState,
      selectedTickets: updatedTickets,
    }));
  }

  function selectCustomerTicket(index: number) {
    const updatedTickets = cloneDeep(checkInState.selectedCustomerTickets);
    const updatedQuantities = { ...checkInState.selectedCustomerTicketQuantities };

    const ticketToAdd = checkInState.availableTickets[index];
    const found = !!updatedTickets?.find(stub => stub?.id === ticketToAdd?.id);
    if (!found) {
      updatedTickets.push(ticketToAdd);
      if (isMultiUseTicket(ticketToAdd)) {
        updatedQuantities[ticketToAdd.id] = 1;
      }
    } else {
      const ticketIndex = updatedTickets.findIndex(stub => stub.id === ticketToAdd.id);

      if (ticketIndex >= 0) {
        updatedTickets.splice(ticketIndex, 1);
        delete updatedQuantities[ticketToAdd.id];
      }
    }

    setCheckInState(prevState => ({
      ...prevState,
      selectedCustomerTickets: updatedTickets,
      selectedCustomerTicketQuantities: updatedQuantities,
    }));
  }

  function updateSelectedCustomerTicketQuantity(stubId: number, quantity: number) {
    setCheckInState(prevState => ({
      ...prevState,
      selectedCustomerTicketQuantities: {
        ...prevState.selectedCustomerTicketQuantities,
        [stubId]: quantity,
      },
    }));
  }

  function updateSelectedTicketQuantity(stubId: number, quantity: number) {
    setCheckInState(prevState => ({
      ...prevState,
      selectedTicketQuantities: {
        ...prevState.selectedTicketQuantities,
        [stubId]: quantity,
      },
    }));
  }

  function getStubStatus(stub: IStub) {
    switch (stub.status) {
      case "valid":
        return (
          <OverlayTrigger
            placement="auto"
            overlay={
              <Tooltip id="headingTooltip">{`${t("secure.facility.tee_sheet.tee_sheet_booking_details.221")}`}</Tooltip>
            }
          >
            <FontAwesomeIcon className="inventory-counts-success" size="1x" icon={faCircleCheck} />
          </OverlayTrigger>
        );
      case "redeemed":
        return (
          <OverlayTrigger
            placement="auto"
            overlay={
              <Tooltip id="headingTooltip">{`${t("secure.facility.tee_sheet.tee_sheet_booking_details.222")}`}</Tooltip>
            }
          >
            <FontAwesomeIcon className="inventory-counts-error" size="1x" icon={faCircleXmark} />
          </OverlayTrigger>
        );
      case "void":
        return (
          <OverlayTrigger
            placement="auto"
            overlay={
              <Tooltip id="headingTooltip">{`${t("secure.facility.tee_sheet.tee_sheet_booking_details.223")}`}</Tooltip>
            }
          >
            <FontAwesomeIcon className="inventory-counts-error" size="1x" icon={faCircleXmark} />
          </OverlayTrigger>
        );
      case "expired":
        return (
          <OverlayTrigger
            placement="auto"
            overlay={
              <Tooltip id="headingTooltip">{`${t("secure.facility.tee_sheet.tee_sheet_booking_details.224")}`}</Tooltip>
            }
          >
            <FontAwesomeIcon className="inventory-counts-error" size="1x" icon={faCircleXmark} />
          </OverlayTrigger>
        );
    }
  }

  function handleMultipleTicketPlayerSelect(participant: IBookingParticipant, id: string) {
    const greenFeeProduct = redeemTicketState?.currentTicket?.redemption_product?.green_fee;
    const powerCartProduct = redeemTicketState?.currentTicket?.redemption_product?.power_cart;

    let greenFeeQuantity: number = greenFeeProduct?.pivot?.quantity;
    let powerCartQuantity: number = powerCartProduct?.pivot?.quantity;

    if (id === "greenFee") {
      const greenFeeParticipantIds = cloneDeep(redeemTicketState?.greenFeeMultipleTicketParticipantIds);
      if (greenFeeParticipantIds.indexOf(participant.id) === -1) {
        greenFeeParticipantIds.push(participant.id);
        greenFeeQuantity = redeemTicketState?.greenFeeQuantity - 1;
      } else {
        const index = greenFeeParticipantIds.indexOf(participant.id);

        if (index >= 0) {
          greenFeeParticipantIds.splice(index, 1);
          greenFeeQuantity = redeemTicketState?.greenFeeQuantity + 1;
        }
      }

      setRedeemTicketState(prevState => ({
        ...prevState,
        greenFeeMultipleTicketParticipantIds: greenFeeParticipantIds,
        greenFeeQuantity: greenFeeQuantity,
      }));
    } else if (id === "powerCart") {
      const powerCartParticipantIds = cloneDeep(redeemTicketState?.powerCartMultipleTicketParticipantIds);
      if (powerCartParticipantIds.indexOf(participant.id) === -1) {
        powerCartParticipantIds.push(participant.id);
        powerCartQuantity = redeemTicketState?.powerCartQuantity - 1;
      } else {
        const index = powerCartParticipantIds.indexOf(participant.id);

        if (index >= 0) {
          powerCartParticipantIds.splice(index, 1);
          powerCartQuantity = redeemTicketState?.powerCartQuantity + 1;
        }
      }

      setRedeemTicketState(prevState => ({
        ...prevState,
        powerCartMultipleTicketParticipantIds: powerCartParticipantIds,
        powerCartQuantity: powerCartQuantity,
      }));
    }
  }

  // console.log(
  //   "%csrc/pages/secure/facility/teesheet/newTeeSheetDetails/NewTeeSheetDetails.tsx:2376 groupPayState",
  //   "color: #007acc;",
  //   groupPayState,
  // );

  function handleRedeemTicketChange(ticket: any, previousTicketPage?: any) {
    if (ticket === redeemTicketState?.currentTicket) {
      return;
    }

    const perUseAssignment = redeemTicketState?.assigningMultiUseTicket === true;
    const { greenFeeQuantity, powerCartQuantity } = getAssignmentRedemptionQuantities(ticket as IStub, perUseAssignment);

    // Restore selections and quantities correctly for previous pages
    if (previousTicketPage) {
      setRedeemTicketState(prevState => ({
        ...prevState,
        currentTicket: ticket,
        greenFeeQuantity,
        powerCartQuantity,
        greenFeeMultipleTicketParticipantIds: [...(previousTicketPage?.selectedGreenFeeParticipants ?? [])],
        powerCartMultipleTicketParticipantIds: [...(previousTicketPage?.selectedPowerCartParticipants ?? [])],
      }));

      return;
    }

    // Normal flow (selecting a new ticket)
    setRedeemTicketState(prevState => ({
      ...prevState,
      currentTicket: ticket,
      greenFeeQuantity,
      powerCartQuantity,
      greenFeeMultipleTicketParticipantIds: [],
      powerCartMultipleTicketParticipantIds: [],
    }));
  }

  function handleNextTicketPage() {
    const completedTicketPages = [...(redeemTicketState?.savedTicketPages ?? [])];

    const redeemTicketPageInfo = {
      pageNumber: redeemTicketState?.currentTicketPage,
      ticket: redeemTicketState?.currentTicket,
      selectedGreenFeeParticipants: redeemTicketState?.greenFeeMultipleTicketParticipantIds,
      selectedPowerCartParticipants: redeemTicketState?.powerCartMultipleTicketParticipantIds,
    };

    completedTicketPages.push(redeemTicketPageInfo);

    if (redeemTicketState?.assigningMultiUseTicket) {
      const nextPage = (redeemTicketState?.currentTicketPage ?? 0) + 1;
      const nextTicket = redeemTicketState?.selectedTickets?.[nextPage - 1];
      const { greenFeeQuantity, powerCartQuantity } = getAssignmentRedemptionQuantities(nextTicket as IStub, true);

      setRedeemTicketState(prevState => ({
        ...prevState,
        savedTicketPages: completedTicketPages,
        greenFeeMultipleTicketParticipantIds: [],
        powerCartMultipleTicketParticipantIds: [],
        currentTicketPage: nextPage,
        currentTicket: nextTicket ?? null,
        greenFeeQuantity,
        powerCartQuantity,
      }));
      return;
    }

    const tickets = [...(redeemTicketState?.ticketsToRedeem ?? [])];
    const filteredTickets = tickets.filter(t => t?.id !== redeemTicketState?.currentTicket?.id);

    setRedeemTicketState(prevState => ({
      ...prevState,
      savedTicketPages: completedTicketPages,
      ticketsToRedeem: filteredTickets,
      greenFeeMultipleTicketParticipantIds: [],
      powerCartMultipleTicketParticipantIds: [],
      currentTicketPage: (redeemTicketState?.currentTicketPage ?? 0) + 1,
      currentTicket: null,
    }));
  }

  function handlePreviousTicketPage() {
    const completedTicketPages = [...(redeemTicketState?.savedTicketPages ?? [])];

    // Find the previous page
    const previousTicketPage = completedTicketPages.find(
      page => page.pageNumber === redeemTicketState?.currentTicketPage - 1,
    );

    if (!previousTicketPage) {
      return;
    }

    // Remove that page from savedTicketPages
    const updatedSavedPages = completedTicketPages.filter(page => page.pageNumber !== previousTicketPage.pageNumber);

    if (redeemTicketState?.assigningMultiUseTicket) {
      handleRedeemTicketChange(previousTicketPage.ticket, previousTicketPage);

      setRedeemTicketState(prevState => ({
        ...prevState,
        savedTicketPages: updatedSavedPages,
        currentTicketPage: previousTicketPage.pageNumber,
      }));
      return;
    }

    const tickets = [...(redeemTicketState?.ticketsToRedeem ?? [])];

    // Add that ticket back to ticketsToRedeem
    tickets.push(previousTicketPage.ticket);

    // Restore the previous ticket’s selections and quantities
    handleRedeemTicketChange(previousTicketPage.ticket, previousTicketPage);

    // Update state
    setRedeemTicketState(prevState => ({
      ...prevState,
      savedTicketPages: updatedSavedPages,
      ticketsToRedeem: tickets,
      currentTicketPage: previousTicketPage.pageNumber,
    }));
  }

  function isNextDisabled(state: IRedeemTicketState) {
    if (
      !state?.assigningMultiUseTicket &&
      (checkInState?.selectedCustomerTickets?.length ?? 0) <= 0 &&
      state?.redeemingMultipleTickets
    ) {
      return true;
    }

    if (state?.redeemingMultipleTickets) {
      const ticket = state?.currentTicket;
      if (!ticket) {
        return true;
      }

      const { greenFeeQuantity: greenFeeQty, powerCartQuantity: powerCartQty } = getAssignmentRedemptionQuantities(
        ticket as IStub,
        state.assigningMultiUseTicket,
      );

      const greenFeeSelected = state?.greenFeeMultipleTicketParticipantIds?.length ?? 0;
      const powerCartSelected = state?.powerCartMultipleTicketParticipantIds?.length ?? 0;

      const allSlotsAssigned =
        (greenFeeQty === 0 || greenFeeSelected >= greenFeeQty) &&
        (powerCartQty === 0 || powerCartSelected >= powerCartQty);

      return !allSlotsAssigned;
    }

    return false;
  }

  const [bookingParticipants, setBookingParticipants] = useState<any[]>([]);

  useEffect(() => {
    if (!state.selectedBooking) {
      return;
    }

    const bookingSlots = [...(teeSheetStore?.selectedTeeTime?.slots ?? [])];

    const filteredSlots = bookingSlots?.filter(slot =>
      isSlotEligibleForTicketFeeRedemption(slot, state.selectedBooking.id),
    );

    const participants = filteredSlots?.map(slot => slot?.booking_participant) ?? [];
    setBookingParticipants(participants);
  }, [state.selectedBooking, teeSheetStore?.selectedTeeTime]);

  const createPlayerNote = async (payload: {
    customer_id: number;
    content: string;
    high_priority: boolean;
    tee_time_booking_id: number;
  }) => {
    const response = await PostCustomerNote(payload, true);

    if (response.status === StatusCode.OK) {
      dispatch(showSuccess(t("Note added successfully")));
      // Refresh the tee times to show the new note
      void dispatch(selectTeeTime(teeSheetStore?.selectedTeeTime?.id, true));
    } else {
      dispatch(showError(t("Failed to add note")));
    }
  };

  function getFilteredDeposits(deposits: Array<IBookingDeposit>) {
    if (deposits && deposits?.length > 0) {
      const uniqueBookings: Array<IBooking> = [];
      //Get all unique bookings
      teeSheetStore?.selectedTeeTime?.slots?.forEach((slot, _, slots) => {
        const foundBooking = uniqueBookings?.find(booking => slot?.booking?.id === booking?.id);
        if (!foundBooking) {
          uniqueBookings?.push({
            ...slot?.booking,
            participants: slots
              ?.filter(participantSlot => participantSlot?.tee_time_booking_id === slot?.tee_time_booking_id)
              ?.map(participantSlot => participantSlot?.booking_participant),
          });
        }
      });
      //Filter deposits by which booking's players items are in the cart
      const filteredDeposits = deposits?.filter(deposit => {
        let keepDeposit = false;
        participantPaidFees?.current?.forEach(participant => {
          if (participant?.green_fee === true || participant?.power_cart_fee === true) {
            const foundBooking = uniqueBookings?.find(booking =>
              booking?.participants?.some(part => part?.id === participant?.booking_participant_id),
            );
            if (
              foundBooking &&
              foundBooking?.deposit_id === deposit?.id &&
              !keepDeposit &&
              deposit?.amount_remaining > 0
            ) {
              keepDeposit = true;
            }
          }
        });
        return keepDeposit;
      });

      const finalDeposits = filteredDeposits?.reduce((finalBookingDeposits, deposit) => {
        const updatedDeposits = [...finalBookingDeposits];
        participantPaidFees?.current?.forEach(participant => {
          const foundBooking = uniqueBookings?.find(booking =>
            booking?.participants?.some(part => part?.id === participant?.booking_participant_id),
          );
          if (foundBooking && foundBooking?.deposit_id === deposit?.id) {
            if (!updatedDeposits?.some(currDeposit => currDeposit?.id === deposit?.id)) {
              updatedDeposits.push({ ...deposit, full_name: foundBooking?.first_name + " " + foundBooking?.last_name });
            }
          }
        });
        return updatedDeposits;
      }, [] as Array<IBookingDeposit & { full_name?: string }>);
      return finalDeposits;
    }
    return undefined;
  }

  return (
    <>
      <div className="booking-details-parent-container ">
        <div className="booking-details-container">
          <div className=" flex justify-between space-date-bar ">
            <div className="flex items-center">
              <Button
                type="secondary"
                size="small"
                className="mr-4"
                onClick={() => {
                  dispatch(selectTeeTimeSuccess(null));
                  history.push(`/admin/teesheet`, { params: { preserveTeeSheetDate: true } });
                }}
              >
                <FontAwesomeIcon icon={faArrowLeft} className="mr-1" />
              </Button>
              <div className="flex items-center gap-6">
                <span className="hour-size">
                  {teeSheetStore.selectedTeeTime?.start_time
                    ? convertTime(teeSheetStore.selectedTeeTime?.start_time)
                    : null}
                </span>

                <span className="text-primary-grey text-m">|</span>

                <span className="text-primary-grey text-m">
                  {moment(`${teeSheetStore.selectedTeeTime?.date}`).format("MMMM Do, YYYY")}
                </span>

                <span className="text-primary-grey text-m">|</span>

                <Badge size="small" type="gray">
                  {teeSheetStore.selectedTeeTime?.division_title}
                  <FontAwesomeIcon icon={["far", "long-arrow-right"]} className="mr-1 ml-1" />
                  {teeSheetStore.selectedTeeTime?.turn_division_title}
                </Badge>
              </div>
            </div>

            <NavigationDropdownNew
              label={t("Options")}
              rightAlign
              sections={[
                [
                  {
                    label: t("secure.facility.tee_sheet.tee_sheet_booking_details.043"),
                    onClick: () =>
                      updateState<IRainCheckState>(
                        { rainCheckActive: true, selectedBookingParticipantId: null },
                        StateType.RainCheckState,
                      ),
                    icon: "umbrella",
                    disabled: !!checkInState.order,
                  },
                  {
                    label: t("secure.facility.tee_sheet.tee_sheet_booking_details.044"),
                    onClick: () =>
                      updateState<IRainCheckState>({ redeemRainCheckActive: true }, StateType.RainCheckState),
                    icon: "ticket",
                    disabled: !!checkInState.order,
                  },
                ],
                [
                  {
                    label: t("secure.facility.tee_sheet.tee_sheet_booking_details.045"),
                    onClick: () => updateState<IGroupPayState>({ groupPayActive: true }, StateType.GroupPayState),
                    icon: "user-group",
                    disabled: !!checkInState.order,
                  },
                ],
                [
                  {
                    label: t("secure.facility.tee_sheet.tee_sheet_booking_details.225"),
                    onClick: () => togglePowerCartVisible(true),
                    icon: "cars",
                    disabled: !!checkInState.order,
                  },
                ],
                [
                  {
                    label: paceTrackerVisible ? t("Hide pace tracker") : t("View pace tracker"),
                    onClick: () => setPaceTrackerVisible(visible => !visible),
                    icon: "clock",
                    disabled: !teeSheetStore.selectedTeeTime?.slots?.some(slot => slot?.booking_participant?.id),
                  },
                ],
                [
                  {
                    label: t("secure.facility.tee_sheet.tee_sheet_booking_details.226"),
                    onClick: () => void handleAddAllFees(teeSheetStore.selectedTeeTime.slots, "green_fees"),
                    icon: "dollar-sign",
                    disabled:
                      !!checkInState.order ||
                      orderProgress?.orderStep === OrderProgress.CREATING_CART ||
                      orderProgress?.orderStep === OrderProgress.ADDING_FEES,
                  },
                  {
                    label: t("secure.facility.tee_sheet.tee_sheet_booking_details.227"),
                    onClick: () => void handleAddAllFees(teeSheetStore.selectedTeeTime.slots, "power_carts"),
                    icon: "car-side",
                    disabled:
                      !!checkInState.order ||
                      orderProgress?.orderStep === OrderProgress.CREATING_CART ||
                      orderProgress?.orderStep === OrderProgress.ADDING_FEES,
                  },
                ],
                [
                  {
                    label: t("Review Player Details"),
                    onClick: () => setReviewPlayersModalVisable(true),
                    icon: "memo",
                    disabled:
                      !!checkInState.order ||
                      orderProgress?.orderStep === OrderProgress.CREATING_CART ||
                      orderProgress?.orderStep === OrderProgress.ADDING_FEES,
                  },
                ],
              ]}
            />
          </div>

          {paceTrackerVisible && teeSheetStore.selectedTeeTime?.slots?.some(slot => slot?.booking_participant?.id) ? (
            <PaceTracker
              {...getGroupPaceTimes(teeSheetStore.selectedTeeTime.slots)}
              bookingParticipantIds={
                teeSheetStore.selectedTeeTime.slots
                  ?.filter(slot => slot?.booking_participant?.id)
                  ?.map(slot => slot.booking_participant.id) ?? []
              }
              onPaceUpdated={() => void refreshTeeTime(false, true)}
              onHide={() => setPaceTrackerVisible(false)}
            />
          ) : null}

          {!moment(teeSheetStore.selectedTeeTime?.date).isSameOrBefore(moment(), "date") ? (
            <div className="mb-4" style={{ marginLeft: "40px", marginRight: "40px" }}>
              <Callout type="warning" title={t("Caution: Checking in future tee time")} content="" />
            </div>
          ) : null}

          <NewTeeSheetBookingDisplay
            initiateEditBookingHandler={(booking, newPlayerAdded) => void handleEditBooking(booking, newPlayerAdded)}
            checkInHandler={slot =>
              updateState<ICheckInState>(
                { manualCheckInVisible: true, manualCheckInSlot: slot },
                StateType.CheckInState,
              )
            }
            noShowBookingHandler={(slot, type, allSlotIds, email) =>
              void handleNoShowBookingParticipant(slot, type, allSlotIds, email)
            }
            chargeNoShowHandler={slot => void handleChargeNoShowModal(slot)}
            showChangePlayerHandler={handleShowChangePlayer}
            cancelBookingParticipantHandler={slot => void handleCancelBookingParticipant(slot)}
            loadCartWaiverHandler={customer_id => void loadCartWaiver(customer_id)}
            loadLiabilityWaiverHandler={(customer_id, waiver_id) => void loadLiabilityWaiver(customer_id, waiver_id)}
            initiateRedeemTicketHandler={customer_id => void handleInitiateRedeemTicket(customer_id)}
            initiateAddFeeHandler={initiateSelectParticipantFee}
            order={checkInState.order}
            powerCartModalVisible={state.powerCartModalVisible}
            togglePowerCartModalVisible={togglePowerCartVisible}
            removeNoShowBookingHandler={slot => void handleRemoveNoShowBooking(slot)}
            orderProgress={orderProgress}
            addFeeHandler={handleAddFee}
            cart={checkInState?.cart}
            removeFeeHandler={(slot, variant, type, event) => void handleRemoveFee(slot, variant, type, event)}
            reloadTeeTimes={() => void refreshTeeTime(false, true)}
            promptCartNumberForSlot={state.promptCartNumberSlot}
            clearPromptCartNumberForSlot={() =>
              updateState<IMainState>({ promptCartNumberSlot: null }, StateType.MainState)
            }
            initiateIssueRainCheckHandler={slot => {
              updateState<IRainCheckState>(
                {
                  rainCheckActive: true,
                  selectedBookingParticipantId: slot.booking_participant.id,
                },
                StateType.RainCheckState,
              );
            }}
            initiateRedeemRainCheckHandler={() =>
              updateState<IRainCheckState>({ redeemRainCheckActive: true }, StateType.RainCheckState)
            }
            createPlayerNote={createPlayerNote}
            reviewPlayersModalVisable={reviewPlayersModalVisable}
            closeReviewPlayersModal={() => setReviewPlayersModalVisable(false)}
          />
        </div>

        {orderProgress.orderStep === OrderProgress.NEW_ORDER ? (
          <div className="teesheet-details-order p-4 flex flex-column items-center justify-center">
            <div className="teesheet-details-order_new_order_icon_container">
              <FontAwesomeIcon icon={faFileCirclePlus} className="self-center" />
            </div>

            <div className="teesheet-details-order_new_order_title">
              {t("secure.facility.tee_sheet.tee_sheet_booking_details.022")}
            </div>

            <div className="teesheet-details-order_new_order_description">
              {t("secure.facility.tee_sheet.tee_sheet_booking_details.023")}
            </div>
          </div>
        ) : (
          <div className="booking-details-cart-container">
            <CartMenuNew
              dataOrigin={{
                stateCart: checkInState?.cart,
                updateState: updateState,
                clearStateCart: handleDeleteOrder,
                deposits: getFilteredDeposits(deposits),
                refreshDeposits: (refresh: boolean) => setRefreshDeposits(refresh),
              }}
            />
          </div>
        )}
      </div>

      <Sheet
        open={addItemState.greenFeeActive}
        size="medium"
        closable
        backDropCancel={false}
        title={t("secure.facility.tee_sheet.tee_sheet_booking_details.046")}
        onCancel={onCancelAddGreenFeeModal}
        cancelText={t("secure.facility.tee_sheet.tee_sheet_booking_details.193")}
        okText={t("secure.facility.tee_sheet.tee_sheet_booking_details.140")}
      >
        {addItemState?.participantFeeLoadingMessage ? (
          <div style={{ display: "flex", height: "100%", margin: "auto" }}>
            <div className="text-center m-auto">
              <div style={{ height: "32px" }}>
                <Spin />
              </div>
              <div>{addItemState?.participantFeeLoadingMessage}</div>
            </div>
          </div>
        ) : (
          <>
            <Input
              type="search"
              onChange={filterGreenFees}
              placeholder={t("secure.facility.tee_sheet.tee_sheet_booking_details.048")}
              value={addItemState.greenfeeSearchQuery}
              autoComplete="off"
            />

            <div className="overflow-auto mt-4">
              <Products
                products={alphaSortProducts(
                  addItemState.greenfeeSearchQuery.trim() !== ""
                    ? foundGreenFees
                    : addItemState.greenFeeFolderItems?.length > 0
                    ? addItemState.greenFeeFolderItems
                    : addItemState.itemSearchResult.length > 0
                    ? addItemState.itemSearchResult
                    : [],
                )}
                useGridPositions={
                  Boolean(addItemState.greenFeeFolderItems?.length) && addItemState.greenfeeSearchQuery.trim() === ""
                }
                productState={addItemState.productState}
                onClick={product => onClickProduct(product, "Green Fee")}
                onCancel={onCancelAddVariantModal}
                onConfirmVariant={variant => openApplyDynamicPricingModal(variant as IVariant)}
                currency={facilityStore?.facility?.default_currency_code}
              />
            </div>
          </>
        )}
      </Sheet>

      <Sheet
        open={addItemState.powerCartFeeActive}
        size="medium"
        closable
        title={t("secure.facility.tee_sheet.tee_sheet_booking_details.049")}
        onCancel={onCancelAddPowerCartModal}
        backDropCancel={false}
        cancelText={t("secure.facility.tee_sheet.tee_sheet_booking_details.193")}
        okText={t("secure.facility.tee_sheet.tee_sheet_booking_details.051")}
      >
        {addItemState?.participantFeeLoadingMessage ? (
          <div style={{ display: "flex", height: "100%", margin: "auto" }}>
            <div className="text-center m-auto">
              <div style={{ height: "32px" }}>
                <Spin />
              </div>
              <div>{addItemState?.participantFeeLoadingMessage}</div>
            </div>
          </div>
        ) : (
          <>
            <Input
              type="search"
              onChange={filterCartItems}
              placeholder={t("secure.facility.tee_sheet.tee_sheet_booking_details.052")}
              value={addItemState.cartSearchQuery}
              autoComplete="off"
            />
            <div className="overflow-auto mt-4">
              <Products
                products={alphaSortProducts(
                  addItemState.cartSearchQuery.trim() !== ""
                    ? foundCartItems
                    : addItemState.powerCartFolderItems?.length > 0
                    ? addItemState.powerCartFolderItems
                    : addItemState.itemSearchResult.length > 0
                    ? addItemState.itemSearchResult
                    : [],
                )}
                useGridPositions={
                  Boolean(addItemState.powerCartFolderItems?.length) && addItemState.cartSearchQuery.trim() === ""
                }
                productState={addItemState.productState}
                onClick={product => onClickProduct(product, "Power Cart")}
                onCancel={onCancelAddVariantModal}
                onConfirmVariant={variant => void handleAddQuickItem(variant as IVariant, "Power Cart")}
                currency={facilityStore?.facility?.default_currency_code}
              />
            </div>
          </>
        )}
      </Sheet>

      <Sheet
        open={noShow.noShowActive}
        size="medium"
        closable
        title={t("secure.facility.tee_sheet.tee_sheet_booking_details.055")}
        onCancel={handleChargeNoShowModalClose}
        onOk={handleNoShowCharge}
        cancelText={t("secure.facility.tee_sheet.tee_sheet_booking_details.056")}
        okText={t("secure.facility.tee_sheet.tee_sheet_booking_details.057")}
        okDisabled={
          noShow.paymentMethodID === null || !noShow.greenFeeProductID || noShow.quantity === 0 ? true : false
        }
        overflow
      >
        <div className="h-full flex flex-col">
          <DataTable
            columns={[
              { label: t("secure.facility.tee_sheet.tee_sheet_booking_details.058"), width: "5%" },
              { label: t("secure.facility.tee_sheet.tee_sheet_booking_details.059"), width: "95%" },
            ]}
          >
            {teeSheetStore.selectedTeeTime?.slots
              ?.filter(
                (filteredSlot: ISlot) =>
                  filteredSlot?.booking_participant?.no_show === true &&
                  filteredSlot?.booking_participant.tee_time_booking_id === noShow.teeTimeBookingId &&
                  !filteredSlot?.booking_participant?.no_show_paid,
              )
              .map((slot: ISlot) => {
                return (
                  <tr
                    key={slot.id}
                    className="clickable"
                    onClick={() => handleNoShowCheckbox(slot.booking_participant?.id)}
                  >
                    <td>
                      <Checkbox
                        size={"medium"}
                        checked={noShow.bookingParticipantIds.some(id => id === slot?.booking_participant?.id)}
                        readOnly
                      />
                    </td>
                    <td>{slot.booking_participant.full_name}</td>
                  </tr>
                );
              })}
          </DataTable>

          <div className="mt-4">
            <Select
              label={t("secure.facility.tee_sheet.tee_sheet_booking_details.060")}
              onChange={(value: any, extraValues: any) => handleNoShowDropDownChange(value, extraValues)}
              defaultValue={noShow.greenFeeProductID}
            >
              {noShow.greenFeeProducts.length >= 1 &&
                noShow.greenFeeProducts?.map(item => {
                  const productTitle = item?.title;
                  const preferredTitle = item?.preferred_title;
                  return (
                    item.variants &&
                    item.variants
                      .filter(variantFiltered => variantFiltered.price > 0)
                      .map((variant, i) => {
                        return (
                          <Option
                            key={i}
                            value={variant.id}
                            name={variant.title}
                            extraValues={{ title: variant.title, price: variant.price }}
                          >
                            <div>
                              <span>{preferredTitle ? preferredTitle : productTitle} </span>
                              {productTitle !== variant.title && (
                                <span className="text-subdued text-sm">{variant.title}</span>
                              )}
                              <span>
                                {" "}
                                -{" "}
                                <LocaleCurrency
                                  currency={facilityStore?.facility?.default_currency_code ?? "cad"}
                                  amount={variant.price}
                                />
                              </span>
                            </div>
                          </Option>
                        );
                      })
                  );
                })}
            </Select>
          </div>
          <div className="mt-auto text-lg">
            <ul>
              <li className="flex justify-end">
                <span className="mr-4 text-medium">{noShow.greenFeeProductTitle}</span>
                <LocaleCurrency
                  currency={facilityStore?.facility?.default_currency_code ?? "cad"}
                  amount={noShow.greenFeeProductPrice ?? 0}
                />
              </li>
              <li className="flex justify-end">
                <span className="mr-4 text-medium">{t("secure.facility.tee_sheet.tee_sheet_booking_details.063")}</span>
                <span>{noShow.quantity}</span>
              </li>
              <li className="flex justify-end text-bold">
                <span className="mr-4">{t("secure.facility.tee_sheet.tee_sheet_booking_details.064")}</span>
                <LocaleCurrency
                  currency={facilityStore?.facility?.default_currency_code ?? "cad"}
                  amount={noShow.quantity * noShow.greenFeeProductPrice}
                />
              </li>
            </ul>
          </div>
        </div>
      </Sheet>

      <Popup
        open={noShow.noPaymentMethodModal}
        type="info"
        title={t("secure.facility.tee_sheet.tee_sheet_booking_details.061")}
        description={t("secure.facility.tee_sheet.tee_sheet_booking_details.062")}
        onOk={() => updateState<INoShowState>({ noPaymentMethodModal: false }, StateType.NoShowState)}
      />

      <Popup
        open={checkInState.manualCheckInVisible}
        closable
        type="info"
        title={t("secure.facility.tee_sheet.tee_sheet_booking_details.174")}
        description={t("secure.facility.tee_sheet.tee_sheet_booking_details.175")}
        onOk={handleManualCheckIn}
        onCancel={() =>
          updateState<ICheckInState>({ manualCheckInVisible: false, manualCheckInSlot: null }, StateType.CheckInState)
        }
      />

      <Portal isMounted={rainCheckState.rainCheckActive}>
        <IssueRainCheckModal
          open={rainCheckState.rainCheckActive}
          slots={teeSheetStore.selectedTeeTime?.slots}
          courseId={teeSheetStore.selectedTeeTime?.course_id}
          bookingParticipantId={rainCheckState.selectedBookingParticipantId ?? undefined}
          onOk={() => {
            closeIssueRainCheck();
            void refreshTeeTime(false);
          }}
          onCancel={closeIssueRainCheck}
        />
      </Portal>


      <Portal isMounted={changePlayerState?.showChangePlayer}>
        <ChangeCustomer
          title={t("secure.facility.tee_sheet.tee_sheet_booking_details.230")}
          currentCustomerTitle={t("secure.facility.tee_sheet.tee_sheet_booking_details.231")}
          newCustomerTitle={t("secure.facility.tee_sheet.tee_sheet_booking_details.232")}
          okText={t("secure.facility.tee_sheet.tee_sheet_booking_details.077")}
          open={changePlayerState.showChangePlayer}
          changeCustomerState={changePlayerState}
          searching={changePlayerState.customerSearching}
          searchResults={changePlayerState.playerSearchResult}
          newCustomerActive={changePlayerState.showNewPlayer}
          onCancel={closeChangePlayer}
          onOk={() => void changeSelectedPlayer()}
          handleSearchQueryChange={changePlayerHandleCustomerSearch}
          handleCustomerSelection={handleChangePlayerSelection}
          handleRemoveSelectedCustomer={() =>
            setChangePlayerState(prevState => ({
              ...prevState,
              selectedCustomer: null,
              playerSearchResult: [],
              customerQuery: "",
            }))
          }
          handleCreateNewCustomer={info => void createNewCustomer(info as ICustomerInfoState)}
          handleCloseCreateNewCustomer={closeCreateNewCustomer}
          handleNewCustomerActive={() => setChangePlayerState(prevState => ({ ...prevState, showNewPlayer: true }))}
        />
      </Portal>

      <Portal isMounted={rainCheckState?.redeemRainCheckActive}>
        <RainCheckRedeem
          open={rainCheckState.redeemRainCheckActive}
          onOk={handleRedeemRainCheck}
          onCancel={closeRedeemRainCheck}
          cart={checkInState.cart}
        />
      </Portal>

      {/* Ticket Select from Slot Options */}
      <Portal isMounted={checkInState.redeemTicketActive}>
        <Sheet
          title={t("secure.facility.tee_sheet.tee_sheet_booking_details.099")}
          open={checkInState?.redeemTicketActive}
          size="medium"
          closable
          onCancel={handleCloseSearchTicket}
          onOk={
            redeemTicketState?.totalTicketPages === redeemTicketState?.currentTicketPage
              ? redeemMultipleTickets
              : redeemTicketState?.redeemingMultipleTickets
              ? handleNextTicketPage
              : handleSearchTicket
          }
          onSecondary={
            redeemTicketState?.redeemingMultipleTickets && redeemTicketState?.currentTicketPage !== 1
              ? handlePreviousTicketPage
              : null
          }
          secondaryText={t("<- Previous ticket")}
          okText={
            redeemTicketState?.totalTicketPages === redeemTicketState?.currentTicketPage
              ? t("Redeem")
              : redeemTicketState?.redeemingMultipleTickets
              ? t("Next ticket ->") //TODO: Translate
              : checkInState?.selectedCustomerTickets.length > 1
              ? t("Next") //TODO: Translate
              : t("Redeem") //TODO: Translate
          }
          cancelText={redeemTicketState?.redeemingMultipleTickets ? t("Back") : t("Cancel")} //TODO: Translate
          okDisabled={isNextDisabled(redeemTicketState)}
        >
          {!redeemTicketState?.redeemingMultipleTickets ? (
            <div className="redeem-ticket-sheet-body">
            <Tabs tabs={tabs} selected={checkInState?.redeemTicketSelected} onSelect={handleSearchTicketTabChange}>
              {checkInState?.redeemTicketSelected === 0 && (
                <>
                  <FormLayout>
                    <FormLayout.Group>
                      <Input
                        id="ticketSearchId"
                        onKeyDown={handleEnterKeydown}
                        value={ticketState.ticketString}
                        placeholder={t("Scan Ticket / Barcode")}
                        onChange={e => setTicketState(prevState => ({ ...prevState, ticketString: e.target.value }))}
                        trailingButtons={[
                          <Button key={1} onClick={handleEnterClick} type="secondary">
                            {t("Enter")}
                          </Button>,
                        ]}
                      />
                    </FormLayout.Group>
                  </FormLayout>

                  <DataTable
                    className="redeem-ticket-table"
                    textWrap
                    columns={[
                      ...(checkInState?.selectedTickets?.length > 0 ? [{ label: "Title" }] : []),
                      ...(checkInState?.selectedTickets?.length > 0
                        ? [
                            { label: t("secure.facility.tee_sheet.tee_sheet_booking_details.234") },
                            { label: t("Barcode") },
                          ]
                        : [{ label: t("Ticket # / Barcode") }]),
                      {
                        label: t("secure.facility.tee_sheet.tee_sheet_booking_details.236"),
                      },
                      { label: "" },
                      { label: "" },
                    ]}
                  >
                    {ticketState?.tickets?.map((sku, index) => {
                      return (
                        <tr key={index}>
                          {checkInState?.selectedTickets?.length > 0 && (
                            <>
                              <td></td>

                              <td>{sku?.sku}</td>
                            </>
                          )}
                          <td>{sku?.sku}</td>
                          <td>{sku?.quantity}</td>
                          <td className="text-right">
                            {!sku.searched ? (
                              <div style={{ display: "inline-flex" }}>
                                <Spin />
                              </div>
                            ) : (
                              <OverlayTrigger
                                placement="auto"
                                overlay={
                                  <Tooltip id="headingTooltip">{`${t(
                                    "secure.facility.tee_sheet.tee_sheet_booking_details.237",
                                  )}`}</Tooltip>
                                }
                              >
                                <FontAwesomeIcon
                                  className="inventory-counts-error"
                                  size="1x"
                                  icon={faCartCircleXmark}
                                  // onClick={() => setVariantNotFoundState({ modalOpen: true, sku: sku.sku })}
                                />
                              </OverlayTrigger>
                            )}
                          </td>

                          <td className="text-right">
                            <FontAwesomeIcon
                              onClick={() => removeTicketSku(index)}
                              icon={faTrashCanXmark}
                              size="1x"
                              className="cursor-pointer"
                            />
                          </td>
                        </tr>
                      );
                    })}

                    {checkInState?.selectedTickets?.map((ticketStub, ticketIndex) => {
                      return (
                        <React.Fragment key={ticketIndex}>
                          <tr className="inventory-counts-product-header">
                            <td>{ticketStub.ticket.title}</td>
                            <td>{ticketStub.code}</td>
                            <td>{ticketStub.code}</td>
                            <td onClick={e => e.stopPropagation()}>
                              {isMultiUseTicket(ticketStub) ? (
                                <TicketRedemptionQuantityInput
                                  id={`tee-sheet-scanned-ticket-quantity-${ticketStub.id}`}
                                  value={getTicketRedemptionQuantity(
                                    ticketStub.id,
                                    checkInState.selectedTicketQuantities,
                                  )}
                                  max={getMaxRedemptionQuantity(ticketStub, bookingParticipants?.length)}
                                  onChange={quantity => updateSelectedTicketQuantity(ticketStub.id, quantity)}
                                />
                              ) : (
                                1
                              )}
                            </td>
                            <td className="text-right">{getStubStatus(ticketStub)}</td>
                            <td className="text-right">
                              <FontAwesomeIcon
                                onClick={() => removeTicket(ticketIndex)}
                                icon={faTrashCanXmark}
                                size="1x"
                                className="cursor-pointer"
                              />
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    })}
                  </DataTable>
                </>
              )}

              {checkInState.redeemTicketSelected === 1 && (
                <>
                  <DataTable
                    className="mt-3 redeem-ticket-table"
                    textWrap
                    columns={[
                      { label: t("secure.facility.tee_sheet.tee_sheet_booking_details.238") },
                      { label: t("secure.facility.tee_sheet.tee_sheet_booking_details.239") },
                      { label: t("secure.facility.tee_sheet.tee_sheet_booking_details.240") },
                      { label: t("Remaining Redemptions") },
                      { label: t("Quantity") },
                      { label: "" },
                    ]}
                    footer={{
                      tableLimit: TICKET_LIMIT,
                      tableOffset: checkInState.availableTicketsOffset,
                      disableNextOffset:
                        !checkInState.availableTickets ||
                        !(checkInState.availableTickets.length === TICKET_LIMIT),
                      handleTableOffset: direction => void handleAvailableTicketsOffset(direction),
                    }}
                  >
                    {checkInState?.availableTickets?.map((ticketStub: any, index: number) => {
                      const pendingUse = teeSheetStore?.selectedTeeTime?.slots?.some(slot =>
                        slot?.booking_participant?.pending_ticket_stub_ids?.some(
                          stub => stub === (ticketStub?.id as number),
                        ),
                      );
                      const isSelected = checkInState.selectedCustomerTickets?.some(stub => stub.id === ticketStub.id);
                      const disableClick =
                        (!isMultiUseTicket(ticketStub as IStub) &&
                          checkInState.selectedCustomerTickets?.length >= (bookingParticipants?.length ?? 1) &&
                          !isSelected) ||
                        pendingUse;
                      const maxRedemptionQuantity = getMaxRedemptionQuantity(
                        ticketStub as IStub,
                        bookingParticipants?.length,
                      );
                      return (
                        <tr
                          key={index}
                          className={disableClick ? "" : "clickable"}
                          onClick={disableClick ? undefined : () => selectCustomerTicket(index)}
                        >
                          <td style={{ padding: "8px 24px" }}>
                            <p className="text-xs">
                              {ticketStub.ticket?.title}{" "}
                              {ticketStub.ticket?.subtitle ? "- " + String(ticketStub?.ticket?.subtitle) : null}
                              {ticketStub?.is_shared ? (
                                <Badge type="primary" size="xsmall">
                                  {t("Shared")}
                                </Badge>
                              ) : null}
                              {pendingUse ? (
                                <Badge type="warning" size="xsmall">
                                  {t("Pending")}
                                </Badge>
                              ) : null}
                            </p>

                            <p className="text-xs">{ticketStub.ticket?.included}</p>
                          </td>

                          <td>
                            <p className="text-xs">{ticketStub.code}</p>
                          </td>

                          <td>
                            <p className="text-xs">{ticketStub.expiry_date ? ticketStub.expiry : "No Expiry"}</p>
                          </td>

                          <td>{ticketStub?.redemptions_remaining}</td>

                          <td onClick={event => event.stopPropagation()}>
                            {isSelected && isMultiUseTicket(ticketStub as IStub) ? (
                              <TicketRedemptionQuantityInput
                                id={`tee-sheet-ticket-quantity-${ticketStub.id}`}
                                value={getTicketRedemptionQuantity(
                                  ticketStub.id as number,
                                  checkInState.selectedCustomerTicketQuantities,
                                )}
                                max={maxRedemptionQuantity}
                                onChange={quantity => updateSelectedCustomerTicketQuantity(ticketStub.id as number, quantity)}
                              />
                            ) : isSelected ? (
                              1
                            ) : null}
                          </td>

                          <td>
                            <div className="pointer-events-none">
                              <Checkbox
                                size={"medium"}
                                checked={isSelected || pendingUse}
                                onChange={() => selectCustomerTicket(index)}
                                disabled={disableClick}
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </DataTable>
                </>
              )}
            </Tabs>
            </div>
          ) : (
            //
            //
            //  Assign Multiple Tickets
            //
            //
            <div className="redeem-multiple-tickets">
              <div className="redeem-multiple-tickets_title_container">
                <div>
                  <p className="redeem-multiple-tickets_title_text">Assign Tickets</p> {/* TODO: Translate */}
                </div>

                <div>
                  <p className="redeem-multiple-tickets_title_subtext">
                    {redeemTicketState?.currentTicketPage} / {redeemTicketState?.selectedTickets?.length} {t("tickets")}{" "}
                    {/* TODO: Translate */}
                  </p>
                </div>
              </div>

              <div className="pt-4 pb-2 ">
                <Select
                  onChange={value => handleRedeemTicketChange(value)}
                  showDropDownOnFocus
                  defaultValue={
                    redeemTicketState?.currentTicket
                      ? redeemTicketState?.currentTicket
                      : redeemTicketState.ticketsToRedeem[0]
                  }
                  // allowClear
                >
                  {redeemTicketState?.ticketsToRedeem?.map((ticket: any, index: number) => {
                    const { greenFeeQuantity, powerCartQuantity } = getAssignmentRedemptionQuantities(
                      ticket as IStub,
                      redeemTicketState.assigningMultiUseTicket,
                    );
                    const { greenFeeItem } = getRedemptionItemSlots(ticket as IStub);
                    const greenFeeProduct = ticket?.redemption_product?.green_fee;
                    const redemptionProductTitle =
                      greenFeeProduct?.title ?? greenFeeItem?.title ?? ticket?.ticket?.title;
                    const redeemTicket = ticket?.ticket;

                    return (
                      <Select.Option key={`${ticket.id}-${ticket.assignmentIndex ?? index}`} value={ticket}>
                        <p className="redeem-multiple-tickets_select_title_text">
                          {redeemTicket?.title}{" "}
                          {redeemTicketState.assigningMultiUseTicket && (
                            <span className="redeem-multiple-tickets_select_subtitle_text">
                              Use {(ticket.assignmentIndex ?? index) + 1}
                            </span>
                          )}
                          {greenFeeQuantity > 0 && (
                            <span className="redeem-multiple-tickets_select_subtitle_text">
                              {" "}
                              {greenFeeQuantity} {redemptionProductTitle ?? "Green fee"}
                            </span>
                          )}
                          {powerCartQuantity > 0 && (
                            <span className="redeem-multiple-tickets_select_subtitle_text">
                              {" "}
                              {powerCartQuantity} Power cart
                            </span>
                          )}
                        </p>
                      </Select.Option>
                    );
                  })}
                </Select>
              </div>

              <div className="mt-4 mb-2 flex justify-between">
                <div>
                  <p className="redeem-multiple-tickets_players_text">{t("Players")}</p> {/* TODO: Translate */}
                </div>

                <div className="flex justify-between w-1/4">
                  <p className="redeem-multiple-tickets_column_text">Green Fee</p> {/* TODO: Translate */}
                  <p className="redeem-multiple-tickets_column_text">Power Cart</p> {/* TODO: Translate */}
                </div>
              </div>

              {redeemTicketState?.multipleTicketParticipants.map((participant: any, index: number) => {
                const participantId = Number(participant.id);
                const state = redeemTicketState;

                const ticket = state?.currentTicket;
                const hasCurrentTicket = !!state?.currentTicket;

                const { greenFeeQuantity, powerCartQuantity } = getAssignmentRedemptionQuantities(
                  ticket as IStub,
                  state.assigningMultiUseTicket,
                );

                const greenFeeSelectedCount = state?.greenFeeMultipleTicketParticipantIds?.length ?? 0;
                const powerCartSelectedCount = state?.powerCartMultipleTicketParticipantIds?.length ?? 0;

                const greenFeeAppliedElsewhere = state?.savedTicketPages?.some(
                  page =>
                    page.pageNumber !== state.currentTicketPage &&
                    page.selectedGreenFeeParticipants.includes(participantId),
                );

                const powerCartAppliedElsewhere = state?.savedTicketPages?.some(
                  page =>
                    page.pageNumber !== state.currentTicketPage &&
                    page.selectedPowerCartParticipants.includes(participantId),
                );

                const disableGreenFeeCheckbox =
                  !hasCurrentTicket ||
                  greenFeeAppliedElsewhere ||
                  greenFeeQuantity === 0 ||
                  (!state?.greenFeeMultipleTicketParticipantIds?.includes(participantId) &&
                    greenFeeSelectedCount >= greenFeeQuantity);

                const disablePowerCartCheckbox =
                  !hasCurrentTicket ||
                  powerCartAppliedElsewhere ||
                  powerCartQuantity === 0 ||
                  (!state?.powerCartMultipleTicketParticipantIds?.includes(participantId) &&
                    powerCartSelectedCount >= powerCartQuantity);

                return (
                  <div key={index} className="redeem-multiple-tickets_customer_container">
                    <div className="redeem-multiple-tickets_customer_info_container">
                      <div className="profile-image_container">
                        <div className="profile-image">
                          <img
                            src={
                              participant?.customer?.profile_image_source !== null
                                ? participant?.customer?.profile_image_source
                                : "/public/images/default_profile_image.svg"
                            }
                            alt="customer_image"
                          />
                        </div>
                      </div>

                      <div>
                        <p className="redeem-multiple-tickets_player_name">
                          {participant?.customer.full_name}

                          {participant?.guest && (
                            <span>
                              {" - "}{" "}
                              <Badge type="gray" size="small">
                                {" "}
                                Guest{" "}
                              </Badge>
                            </span>
                          )}
                        </p>

                        <p className="redeem-multiple-tickets_player_type">
                          {participant?.customer.customer_type}
                          <span className="redeem-multiple-tickets_products_added_text">
                            {greenFeeAppliedElsewhere ? "Green fee" : ""}{" "}
                            {greenFeeAppliedElsewhere && powerCartAppliedElsewhere ? ", " : ""}{" "}
                            {powerCartAppliedElsewhere ? "Power cart" : null}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="flex w-1/4 justify-between">
                      <div className="w-full flex justify-center">
                        <Checkbox
                          size="small"
                          id="greenFee"
                          checked={redeemTicketState?.greenFeeMultipleTicketParticipantIds?.includes(
                            Number(participant.id),
                          )}
                          disabled={disableGreenFeeCheckbox}
                          onChange={() =>
                            handleMultipleTicketPlayerSelect(participant as IBookingParticipant, "greenFee")
                          }
                        />
                      </div>
                      <div
                        className="w-full flex justify-center"
                        // onClick={() => handleMultipleTicketPlayerSelect(participant, "powerCart")}
                      >
                        <Checkbox
                          size="small"
                          id="powerCart"
                          checked={redeemTicketState?.powerCartMultipleTicketParticipantIds?.includes(
                            Number(participant.id),
                          )}
                          disabled={disablePowerCartCheckbox}
                          onChange={() =>
                            handleMultipleTicketPlayerSelect(participant as IBookingParticipant, "powerCart")
                          }
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </Sheet>
      </Portal>

      <Popup
        open={state.clearCartActive}
        type="warning"
        title={t("secure.facility.tee_sheet.tee_sheet_booking_details.154")}
        description={t("secure.facility.tee_sheet.tee_sheet_booking_details.155")}
        onOk={handleDeleteOrder}
        okText={t("secure.facility.tee_sheet.tee_sheet_booking_details.156")}
        cancelText={t("secure.facility.tee_sheet.tee_sheet_booking_details.157")}
        onCancel={() => {
          setState(prevState => ({ ...prevState, clearCartActive: false }));
        }}
        backDropCancel={true}
      />

      <Popup
        open={checkInState.ticketValidSuccess}
        type={checkInState.getTicketValidateData?.stub?.status !== "valid" ? "info" : "success"}
        title={
          checkInState.getTicketValidateData?.stub?.status === "redeemed"
            ? t("secure.facility.tee_sheet.tee_sheet_booking_details.163")
            : checkInState.getTicketValidateData?.stub?.status === "expired"
            ? t("secure.facility.tee_sheet.tee_sheet_booking_details.164")
            : checkInState.getTicketValidateData?.stub?.status === "void"
            ? t("secure.facility.tee_sheet.tee_sheet_booking_details.165")
            : t("secure.facility.tee_sheet.tee_sheet_booking_details.108")
        }
        description={
          checkInState.getTicketValidateData?.stub?.status === "redeemed"
            ? t("secure.facility.tee_sheet.tee_sheet_booking_details.166")
            : checkInState.getTicketValidateData?.stub?.status === "expired"
            ? t("secure.facility.tee_sheet.tee_sheet_booking_details.167")
            : checkInState.getTicketValidateData?.stub?.status === "void"
            ? t("secure.facility.tee_sheet.tee_sheet_booking_details.168")
            : t("secure.facility.tee_sheet.tee_sheet_booking_details.108")
        }
        onOk={handleTicketValidSuccess}
        okText={t("Redeem")}
        okDisabled={checkInState.getTicketValidateData?.stub?.status !== "valid" ? true : false}
        onCancel={() =>
          updateState<ICheckInState>(
            {
              ticketValidSuccess: false,
              redeem_ticket_code: "",
              getTicketValidateData: {},
            },
            StateType.CheckInState,
          )
        }
      >
        <p>{checkInState.getTicketValidateData.stub?.ticket?.title}</p>
        <p>{checkInState.getTicketValidateData.stub?.ticket?.included}</p>
        <p>
          {checkInState.getTicketValidateData.stub?.expiry_date ? (
            <span>
              {t("secure.facility.tee_sheet.tee_sheet_booking_details.109")}{" "}
              {checkInState.getTicketValidateData.stub?.expiry_date}
            </span>
          ) : (
            <span>{t("secure.facility.tee_sheet.tee_sheet_booking_details.110")}</span>
          )}
        </p>
        {checkInState.getTicketValidateData.stub?.description && (
          <Markdown markdownText={checkInState.getTicketValidateData.stub.description} />
        )}
      </Popup>

      <Popup
        open={checkInState.ticketValidWarning}
        type="warning"
        title={t("secure.facility.tee_sheet.tee_sheet_booking_details.111")}
        description=" "
        onOk={handleTicketValidWarning}
      />

      {/* Tee time cancelled pop up */}
      <Popup
        open={state.teeTimeCancelledPopupVisible}
        type="warning"
        title={t("secure.facility.tee_sheet.tee_sheet_booking_details.112")}
        description={t("secure.facility.tee_sheet.tee_sheet_booking_details.113")}
        onOk={handleTeeTimeCancelledPopupRefresh}
        okText={t("secure.facility.tee_sheet.tee_sheet_booking_details.114")}
        onCancel={handleTeeTimeCancelledPopupRefresh}
        backDropCancel={false}
      />

      {/* Group Pay Modal */}
      <div className="group-pay-modal-ok-button">
        <Sheet
          title={t("secure.facility.tee_sheet.tee_sheet_booking_details.134")}
          open={groupPayState.groupPayActive}
          supportText={t("Combine payments for players in other tee times into one transaction.")}
          size={groupPayState?.groupPayTeeTimes?.length === 0 ? "small" : "medium"}
          closable
          onCancel={() =>
            updateState<IGroupPayState>({ groupPayActive: false, groupPayTeeTimes: null }, StateType.GroupPayState)
          }
          cancelText={t("secure.facility.tee_sheet.tee_sheet_booking_details.135")}
        >
          {!groupPayState?.groupPayTeeTimes ? (
            <div style={{ display: "flex", height: "100%", margin: "auto" }}>
              <div className="text-center m-auto">
                <div style={{ height: "32px" }}>
                  <Spin />
                </div>
                <div>{t("secure.facility.tee_sheet.tee_sheet_booking_details.241")}</div>
              </div>
            </div>
          ) : groupPayState?.groupPayTeeTimes?.length === 0 ? (
            <Callout
              type="info"
              title={t("Group Pay Unavailable")}
              content={t(
                "Group pay requires at least one payable booking today. Add another booking or have teammates pay separately.",
              )}
            />
          ) : (
            <>
              <div className="group-pay-player-search">
                <p className="font-semibold mb-2">Add to current order:</p>
                <Input
                  //label={t("Add to current order")}
                  value={groupPayState.playerSearch}
                  onChange={(value: any) =>
                    updateState<IGroupPayState>({ playerSearch: value.target.value }, StateType.GroupPayState)
                  }
                  type="search"
                  placeholder={t("secure.facility.tee_sheet.tee_sheet_booking_details.136")}
                  onSearchClear={() => setGroupPayState(prev => ({ ...prev, playerSearch: "" }))}
                  //className={"m-2"}
                />
              </div>
              <div>
                {groupPayState.groupPayTeeTimes?.map((teeTime, index) => {
                  if (
                    teeTime.slots.some(slot =>
                      slot.booking_participant?.full_name
                        .toLowerCase()
                        .includes(groupPayState.playerSearch.toLowerCase()),
                    )
                  ) {
                    return (
                      <div key={index}>
                        <div className="group-pay-time-container">
                          <p className="text-semibold text-xl mb-2 mt-4">
                            {teeTime.shotgun_application_id ? (
                              teeTime.start_hole
                            ) : (
                              <>
                                <FontAwesomeIcon icon={faClock} /> {convertTime(teeTime.start_time)}
                              </>
                            )}
                          </p>
                          {!checkInState?.cart ? (
                            <Button
                              type="text"
                              size="medium"
                              onClick={void createCart()}
                              loading={orderProgress.orderStep === OrderProgress.CREATING_CART}
                            >
                              {t("secure.facility.tee_sheet.tee_sheet_booking_details.242")}
                            </Button>
                          ) : (
                            <Button
                              className="mt-4"
                              type="text"
                              size="medium"
                              onClick={() => void addAllGroupPay(teeTime?.slots)}
                            >
                              <FontAwesomeIcon className="mr-2" icon={faPlus} />{" "}
                              {t("secure.facility.tee_sheet.tee_sheet_booking_details.243")}
                            </Button>
                          )}
                        </div>

                        {teeTime.slots
                          ?.filter(
                            filteredSlot =>
                              filteredSlot.booking_participant?.check_in_status === "unchecked" &&
                              filteredSlot.booking_participant.full_name
                                .toLowerCase()
                                .includes(groupPayState.playerSearch.toLowerCase()),
                          )
                          .map((slot, slotIndex) => {
                            const currentParticipant = participantPaidFees?.current.find(
                              participant => participant?.booking_participant_id === slot?.booking_participant?.id,
                            );
                            const green_fee_added = currentParticipant?.green_fee;
                            const power_cart_fee_added = currentParticipant?.power_cart_fee;

                            return (
                              <div
                                key={slotIndex}
                                className={classNames(
                                  "rounded-xl",
                                  "border",
                                  "border-gray-400",
                                  "p-2",
                                  "flex",
                                  "items-center",
                                  "w-100",
                                  "justify-between",
                                  "mb-2",
                                )}
                              >
                                <div className="flex gap-2 items-center">
                                  <div className="avatar-image">
                                    <p>
                                      {" "}
                                      {slot.booking_participant?.first_name?.charAt(0)}
                                      {slot.booking_participant?.last_name?.charAt(0)}{" "}
                                    </p>
                                  </div>

                                  <div>
                                    <p className="text-semibold text-lg">
                                      {slot.booking_participant?.full_name}{" "}
                                      {slot.booking_participant.guest && "- Guest"}
                                    </p>

                                    <p className="text-semibold text-xs text-gray-400">
                                      {slot.booking_participant?.customer.customer_type}
                                    </p>
                                  </div>

                                  {/* <div>
                                      <Badge
                                        size="small"
                                        type="gray"
                                      >
                                      {slot.booking.confirmation_number}
                                      </Badge>
                                    </div> */}

                                  {slot?.booking_participant?.green_fee_paid ? (
                                    <div>
                                      <Badge type="success" size="small">
                                        {t("secure.facility.tee_sheet.tee_sheet_booking_details.197")}
                                      </Badge>
                                    </div>
                                  ) : null}

                                  {slot?.booking_participant?.power_cart_paid ? (
                                    <div>
                                      <Badge type="success" size="small">
                                        {t("secure.facility.tee_sheet.tee_sheet_booking_details.198")}
                                      </Badge>
                                    </div>
                                  ) : null}
                                </div>

                                <div className="group-pay-items-container booking-display-new">
                                  <Button
                                    type={green_fee_added ? "primary" : "secondary"}
                                    size="medium"
                                    className={classNames("ml-auto")}
                                    icon={
                                      currentParticipant?.green_fee_loading ? (
                                        <FontAwesomeIcon size="1x" icon={faSpinnerThird} spin fade />
                                      ) : undefined
                                    }
                                    onClick={e =>
                                      !green_fee_added
                                        ? void handleAddFee(
                                            slot,
                                            {
                                              id: slot?.booking_participant?.green_fee_variant_id,
                                              variantTitle: slot?.booking_participant?.green_fee_variant_title,
                                              productTitle: slot?.booking_participant?.green_fee_product_title,
                                            },
                                            null,
                                            e,
                                          )
                                        : void handleRemoveFee(
                                            slot,
                                            slot?.booking_participant?.green_fee_variant_id,
                                            "green_fee",
                                            e,
                                          )
                                    }
                                    disabled={
                                      slot?.booking_participant?.green_fee_paid ||
                                      !slot?.booking_participant?.green_fee_variant_id ||
                                      currentParticipant?.green_fee_loading ||
                                      orderProgress.orderStep === OrderProgress.CREATING_CART ||
                                      !!checkInState?.order
                                    }
                                  >
                                    {green_fee_added && !currentParticipant?.green_fee_loading ? (
                                      <div className="group-pay-fees">
                                        {" "}
                                        <FontAwesomeIcon
                                          fixedWidth
                                          icon={faCheck}
                                          className={"group-pay-default-icon mr-2"}
                                        />{" "}
                                        <FontAwesomeIcon
                                          fixedWidth
                                          icon={faTrashCan}
                                          className={"group-pay-hover-icon"}
                                        />{" "}
                                      </div>
                                    ) : undefined}{" "}
                                    Green Fee
                                  </Button>

                                  <Button
                                    type={power_cart_fee_added ? "primary" : "secondary"}
                                    size="medium"
                                    className={classNames("ml-auto")}
                                    icon={
                                      currentParticipant?.power_cart_fee_loading ? (
                                        <FontAwesomeIcon size="1x" icon={faSpinnerThird} spin fade />
                                      ) : undefined
                                    }
                                    onClick={e =>
                                      !power_cart_fee_added
                                        ? void handleAddFee(
                                            slot,
                                            null,
                                            {
                                              id: slot?.booking_participant?.power_cart_variant_id,
                                              variantTitle: slot?.booking_participant?.power_cart_variant_title,
                                              productTitle: slot?.booking_participant?.power_cart_product_title,
                                            },
                                            e,
                                          )
                                        : void handleRemoveFee(
                                            slot,
                                            slot?.booking_participant?.power_cart_variant_id,
                                            "power_cart_fee",
                                            e,
                                          )
                                    }
                                    disabled={
                                      slot?.booking_participant?.power_cart_paid ||
                                      !slot?.booking_participant?.power_cart_variant_id ||
                                      currentParticipant?.power_cart_fee_loading ||
                                      orderProgress.orderStep === OrderProgress.CREATING_CART ||
                                      !!checkInState?.order
                                    }
                                  >
                                    {power_cart_fee_added && !currentParticipant?.power_cart_fee_loading ? (
                                      <div className="group-pay-fees">
                                        {" "}
                                        <FontAwesomeIcon
                                          fixedWidth
                                          icon={faCheck}
                                          className={"group-pay-default-icon mr-2"}
                                        />{" "}
                                        <FontAwesomeIcon
                                          fixedWidth
                                          icon={faTrashCan}
                                          className={"group-pay-hover-icon"}
                                        />{" "}
                                      </div>
                                    ) : undefined}{" "}
                                    Power Cart
                                  </Button>
                                </div>
                              </div>
                            );
                          })}
                        <Divider className="mt-4 mb-2" />
                      </div>
                    );
                  }
                })}
              </div>
            </>
          )}
        </Sheet>
      </div>

      <Portal isMounted={editBookingModal.isOpen}>
        <BookingModalEdit
          cartsAvailable={editBookingModal.cartsAvailable}
          selectedBooking={editBookingModal.selectedBooking}
          teeTimeLock={editBookingModal.teeTimeLock}
          refreshTeeTime={true}
          loading={editBookingModal.loading}
          loadingText={editBookingModal.loadingText}
          reloadTeeTimes={() => void refreshTeeTime(true, false)}
          reloadTeeTime={() => void refreshTeeTime(true, false)}
          openDuplicateBookingModal={(booking, teeTime) =>
            updateDuplicateBookingModal({ isOpen: true, booking, teeTime })
          }
        />
      </Portal>

      <OrderCompletePopup
        open={orderCompletePopup.isOpen}
        setOpen={handleBackToCheckIn}
        order={checkInState.order}
        tee_time_id={Number(teetimeId)}
        teeTimeBookingId={activeCartWaiverBookingId}
        cartWaiverLimit={activeCartWaiverLimit}
        waiversPrinted={activeCartWaiversPrinted}
        onCartWaiverPrinted={handleCartWaiverPrinted}
        returnable={true}
        disableDuringLoad
        loading={orderCompletePopup.loading}
        transactionComplete={orderCompletePopup.transactionComplete}
        teeSheetCheckIn
        ticketStubIds={stubsToRedeem && stubsToRedeem?.length > 0 ? stubsToRedeem : undefined}
      />

      <Prompt
        when={!!checkInState.order && !orderCompletePopup?.isOpen}
        message={() => `${t("secure.facility.tee_sheet.tee_sheet_booking_details.245")}`}
      />

      <Popup
        type="info"
        open={state.applyDynamicPricingModal}
        title={t("Apply Dynamic Pricing")}
        description={t(
          "This customer booked online and dynamic pricing was applied. Would you like to apply the altered green fee price to the newly selected one?",
        )}
        okText={t("Apply")}
        onOk={() => applyDynamicPricing()}
        onCancel={() => closeApplyDynamicPricingModal()}
      />

      <Portal isMounted={duplicateBookingModal?.isOpen}>
        <DuplicateBookingModal
          open={duplicateBookingModal?.isOpen}
          booking={duplicateBookingModal.booking}
          teetime={duplicateBookingModal.teeTime}
          facility={facilityStore?.facility}
          onClose={() => {
            void closeDuplicateBookingModal();
          }}
        />
      </Portal>
    </>
  );
};

export default NewTeeSheetDetails;
